<template>
  <!-- modals start -->

  <div class="modal fade" id="editUser" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-simple modal-edit-user">
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-8">
            <h4>{{ $t("accounts.edit_account_details") }}</h4>
          </div>
          <form id="editUserForm" class="row g-6" onsubmit="return false">
            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.first_name") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-user"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.first_name"
                  :placeholder="`${$t('accounts.first_name')}`"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.last_name") }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-user-plus"></i>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.last_name"
                  :placeholder="`${$t('accounts.last_name')}`"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.father_name") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-man"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.father_name"
                  :placeholder="`${$t('accounts.father_name')}`"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.mother_name") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-woman"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.mother_name"
                  :placeholder="`${$t('accounts.mother_name')}`"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.national_id") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-id"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.national_id"
                  :placeholder="`${$t('accounts.national_id')}`"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.phone") }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-device-mobile"></i>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.phone"
                  dir="ltr"
                  :placeholder="`${$t('accounts.phone')}`"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.phone_line") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-phone"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.phone_line"
                  :placeholder="`${$t('accounts.phone_line')}`"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.email") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-mail"></i></div>
                <input
                  type="email"
                  class="form-control"
                  v-model="account.email"
                  :placeholder="`${$t('accounts.email')}`"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.country") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-flag"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.country"
                  :placeholder="`${$t('accounts.country')}`"
                />
                <!-- <select
                  id="country"
                  class="form-select"
                  v-model="account.country"
                >
                  <option selected disabled>{{
                    $t("accounts.select_country")
                  }}</option>
                  <option value="syria">Syria</option>
                  <option value="turkey">Turkey</option>
                  <option value="egypt">Egypt</option>
                  <option value="iraq">Iraq</option>
                  <option value="jordan">Jordan</option>
                  <option value="libia">Libia</option>
                  <option value="other">Other</option>
                </select> -->
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.state") }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-map-pin"></i>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.state"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.city") }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-building-community"></i>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.city"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{
                $t("accounts.neighborhood")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-building"></i>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.neighborhood"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.street") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-road"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.street"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{
                $t("accounts.address_details")
              }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-home"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.address"
                  :placeholder="$t('accounts.ex_apartment_number')"
                />
              </div>
            </div>

            <div
              class="col-12 col-md-6"
              v-if="this.$store.getters.settings.type == 'local'"
            >
              <form
                id="id_image_front"
                action="/upload"
                face="front"
                class="dropzone needsclick dropzone-basic"
                accept="image/png, image/jpeg, .png, .jpg, .jpeg"
                method="post"
                enctype="multipart/form-data"
              >
                <div class="dz-message needsclick">
                  {{ $t("accounts.id_image_front") }}
                  <span class="note needsclick">{{
                    $t("settings.drop_files_or_click_to_upload")
                  }}</span>
                </div>
                <div class="fallback">
                  <input name="file" type="file" accept="image/*" />
                </div>
              </form>
            </div>

            <div
              class="col-12 col-md-6"
              v-if="this.$store.getters.settings.type == 'local'"
            >
              <form
                id="id_image_back"
                action="/upload"
                face="back"
                class="dropzone needsclick dropzone-basic"
                accept="image/png, image/jpeg, .png, .jpg, .jpeg"
                method="post"
                enctype="multipart/form-data"
              >
                <div class="dz-message needsclick">
                  {{ $t("accounts.id_image_back") }}
                  <span class="note needsclick">{{
                    $t("settings.drop_files_or_click_to_upload")
                  }}</span>
                </div>
                <div class="fallback">
                  <input name="file" type="file" accept="image/*" />
                </div>
              </form>
            </div>

            <!-- <div class="col-12 col-md-6">
              <label class="form-label" for="longitude">{{
                $t("accounts.longitude")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-navigation"></i>
                </div>
                <input
                  type="text"
                  id="longitude"
                  class="form-control"
                  placeholder="Longitude"
                  v-model="account.longitude"
                />
              </div>
            </div> -->

            <div class="col-12 col-md-12">
              <label class="form-label">{{
                $t("accounts.gps_coordinates")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-navigation-up"></i>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.gps_coordinates"
                  placeholder="lat,lng"
                />
              </div>
            </div>

            <div class="col-12">
              <label class="form-label">{{ $t("accounts.notes") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-note"></i></div>
                <textarea
                  class="form-control"
                  rows="2"
                  v-model="account.notes"
                  :placeholder="`${$t('accounts.notes')}`"
                ></textarea>
              </div>
            </div>

            <div class="col-12 text-center">
              <button
                type="button"
                class="btn btn-primary me-3"
                @click="submitAccountChanges"
              >
                {{ $t("control.submit") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="editAccountD" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-8">
            <h4>{{ $t("accounts.edit_account_details") }}</h4>
          </div>
          <form class="row g-4" autocomplete="off">
            <div class="col-12">
              <label class="form-label">{{ $t("accounts.username") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-at"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="account.username"
                  oninput="this.value=this.value.replace(/[^a-zA-Z0-9_.\-@\s]/g,'');"
                  autocomplete="new-password"
                  dir="auto"
                  @input="validate"
                  :placeholder="`${$t('accounts.username')}`"
                  :disabled="!hasPrivilege('accounts_edit_username_accounts')"
                  :class="{ 'is-invalid': errors.username }"
                />
              </div>
            </div>

            <div class="col-12">
              <label class="form-label">{{ $t("accounts.password") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-lock"></i></div>
                <input
                  type="password"
                  class="form-control"
                  ref="password_input"
                  autocomplete="new-password"
                  v-model="account.password"
                  @input="validate"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  aria-describedby="basic-default-password2"
                  :disabled="!hasPrivilege('accounts_edit_password_accounts')"
                  :class="{ 'is-invalid': errors.password }"
                />
                <span
                  v-if="hasPrivilege('accounts_view_accounts_passwords')"
                  @click="
                    $refs.password_input.type =
                      $refs.password_input.type === 'password'
                        ? 'text'
                        : 'password'
                  "
                  ref="password_input_eye"
                  class="input-group-text cursor-pointer"
                  ><i class="ti ti-eye-off"></i
                ></span>
              </div>
            </div>

            <div
              v-if="
                hasPrivilege('accounts_edit_profile_accounts') &&
                  this.user.type != 'reseller'
              "
              class="col-12 col-md-6"
            >
              <div class="input-group">
                <label class="form-label">{{ $t("accounts.profile") }}</label>
                <div class="input-group">
                  <div class="input-group-text">
                    <i class="ti ti-brand-databricks"></i>
                  </div>
                  <select v-model="account.profile_id" class="form-select">
                    <option selected disabled>{{
                      $t("accounts.profile")
                    }}</option>
                    <option
                      v-for="(profile, index) in profiles"
                      :key="profile.id"
                      :value="profile.id"
                      dir="ltr"
                      >{{ profile.name }}</option
                    >
                  </select>
                </div>
              </div>
            </div>

            <div
              v-if="
                hasPrivilege('accounts_edit_profile_accounts') &&
                  user.type != 'reseller'
              "
              class="col-12 col-md-6"
            >
              <label class="form-label">{{
                $t("accounts.next_profile")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-device-laptop"></i>
                </div>
                <select
                  class="form-select"
                  v-model="account.next_profile_id"
                  :disabled="
                    !hasPrivilege('accounts_edit_next_profile_accounts')
                  "
                >
                  <option :value="null">{{ $t("control.none") }}</option>
                  <option
                    v-for="(profile, index) in profiles"
                    :key="index"
                    :value="profile.id"
                    >{{ profile.name }}
                  </option>
                </select>
              </div>
            </div>

            <div v-if="this.user.type != 'reseller'" class="col-12 col-md-6">
              <label for="flatpickr-datetime" class="form-label">{{
                $t("accounts.expires_at")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-calendar-time"></i>
                </div>
                <input
                  v-model="account.fixed_expiration"
                  type="datetime-local"
                  class="form-control"
                  placeholder="YYYY-MM-DD HH:MM"
                  :disabled="
                    this.user.type == 'reseller' ||
                      !hasPrivilege('accounts_edit_expiration_accounts')
                  "
                />
              </div>
            </div>

            <div
              class="col-12 col-md-6"
              v-if="hasPrivilege('accounts_reseller_accounts')"
            >
              <label class="form-label" for="agent">{{
                $t("accounts.reseller")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-user-shield"></i>
                </div>
                <select v-model="account.reseller_id" class="form-select">
                  <option selected disabled>{{
                    $t("accounts.select_reseller")
                  }}</option>
                  <option :value="null">{{ $t("control.none") }}</option>
                  <option
                    v-for="(reseller, index) in resellers"
                    :key="reseller.id"
                    :value="reseller.id"
                    >{{ reseller.email }}</option
                  >
                </select>
              </div>
            </div>

            <div v-if="user.type != 'reseller'" class="col-12 col-md-6">
              <label class="form-label">{{
                $t("accounts.allowed_devices")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-device-laptop"></i>
                </div>
                <input
                  type="number"
                  class="form-control"
                  v-model="account.allowed_sessions"
                  placeholder="e.g. 2"
                  min="1"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">{{ $t("accounts.has_ip") }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-device-laptop"></i>
                </div>
                <div class="input-group-text">
                  <input
                    v-model="account.has_static_ip"
                    class="form-check-input mt-0"
                    type="checkbox"
                    value=""
                    aria-label="Checkbox for following text input"
                  />
                </div>
                <input
                  :disabled="!account.has_static_ip"
                  v-model="account.ip_address"
                  type="text"
                  class="form-control"
                  aria-label="Text input with checkbox"
                />
              </div>
            </div>

            <div
              class="col-12 col-md-6"
              v-if="hasPrivilege('ip_addresses_edit_account_ip_address')"
            >
              <label class="form-label">
                {{ $t("ips.pool.name") }}
              </label>
              <select
                class="form-select"
                v-model="account.ip_pool_id"
                @change="
                  fetchPoolIps(true);
                  validate();
                "
              >
                <option :value="null">N/A</option>
                <option
                  v-for="pool in ip_pools"
                  v-bind:key="pool.id"
                  :value="pool.id"
                  dir="ltr"
                >
                  {{ pool.name }}
                </option>
              </select>
            </div>
            <div
              class="col-12 col-md-6"
              v-if="hasPrivilege('ip_addresses_edit_account_ip_address')"
            >
              <label class="form-label">{{ $t("ips.pool.ip_address") }}</label>
              <select
                class="form-select"
                v-model="account.private_ip_id"
                @change="validate"
                :disabled="private_ips.length < 1"
              >
                <option :value="null">N/A</option>
                <option
                  v-for="ip in private_ips"
                  v-bind:key="ip.id"
                  :value="ip.id"
                  dir="ltr"
                >
                  {{ ip.ip_address }}
                </option>
              </select>
            </div>
            <div
              class="col-12 col-md-6"
              v-if="hasPrivilege('ip_addresses_edit_account_ip_address')"
            >
              <label class="form-label" for="">{{
                $t("ips.public.public_address")
              }}</label>
              <select
                class="form-select"
                v-model="account.public_ip_port_id"
                :disabled="account.private_ip_id == ''"
                @change="validate"
                :class="{ 'is-invalid': errors.public_ip_port }"
              >
                <option :value="null">N/A</option>
                <option
                  v-for="ip in public_ips"
                  v-bind:key="ip.id"
                  :value="ip.id"
                  dir="ltr"
                >
                  {{ ip.range }}
                </option>
              </select>
              <div v-if="errors.public_ip_port" class="invalid-feedback">
                {{ errors.public_ip_port }}
              </div>
            </div>

            <div
              class="col-12 col-md-6"
              v-if="hasPrivilege('ip_addresses_edit_account_ip_address')"
            >
              <label class="form-label">{{ $t("accounts.is_mac") }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-device-laptop"></i>
                </div>
                <div class="input-group-text">
                  <input
                    v-model="account.is_mac"
                    class="form-check-input mt-0"
                    type="checkbox"
                    value=""
                    aria-label="Checkbox for following text input"
                  />
                </div>
                <input
                  type="text"
                  :disabled="!account.is_mac"
                  v-model="account.mac_address"
                  class="form-control"
                  aria-label="Text input with checkbox"
                />
              </div>
            </div>

            <div class="col-12 text-center mt-8">
              <button
                type="button"
                class="btn btn-primary me-3"
                :disabled="!validated"
                @click="submitAccountDetailsChanges"
              >
                {{ $t("control.submit") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <transition name="fade">
    <RenewAccountProfile
      v-if="showRenew && hasPrivilege('accounts_renew_accounts')"
      :visible="showRenew"
      :selected-account="account"
      @updated="confirmRenew"
      @hide="showRenew = false"
    />
  </transition>

  <div class="modal fade" id="tempSpeedModal" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2">{{ $t("accounts.temporary_speed_change") }}</h4>
          </div>
          <form id="temporarySpeedForm" class="row g-4">
            <div class="col-12">
              <label class="form-label">{{ $t("accounts.duration") }}</label>
              <div class="input-group">
                <span class="input-group-text"
                  ><i class="ti ti-clock"></i
                ></span>
                <input
                  type="number"
                  class="form-control"
                  v-model="temp_speed.session_seconds"
                  min="1"
                />
                <select
                  class="form-select"
                  v-model="temp_speed.factor"
                  style="max-width: 120px;"
                >
                  <option value="3600">{{ $t("accounts.hours") }}</option>
                  <option value="60">{{ $t("accounts.minutes") }}</option>
                </select>
              </div>
            </div>

            <div class="col-12">
              <label class="form-label">{{
                $t("accounts.temp_download_speed")
              }}</label>
              <div class="input-group">
                <span class="input-group-text"
                  ><i class="ti ti-download"></i
                ></span>
                <input
                  type="number"
                  class="form-control"
                  v-model="temp_speed.download_rate_kb"
                  placeholder="e.g. 4"
                  min="1"
                />
              </div>
            </div>

            <div class="col-12">
              <label class="form-label">{{
                $t("accounts.temp_upload_speed")
              }}</label>
              <div class="input-group">
                <span class="input-group-text"
                  ><i class="ti ti-upload"></i
                ></span>
                <input
                  type="number"
                  v-model="temp_speed.upload_rate_kb"
                  class="form-control"
                  placeholder="e.g. 1"
                  min="1"
                />
              </div>
            </div>

            <div class="col-12 text-center mt-5">
              <button
                type="button"
                class="btn btn-primary me-3"
                @click="submitTemporarySpeedChange"
              >
                {{ $t("control.apply") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="depositDialogVisible"
    class="modal fade"
    id="DepositModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-success">
              {{ $t("accounts.money.deposit") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />

          <form class="row g-4 mt-2" onsubmit="return false">
            <!-- <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("accounts.deposit_date")
              }}</label>
              <input
                type="datetime-local"
                v-model="deposit.date"
                class="form-control"
              />
            </div> -->
            <div class="col-12">
              <label class="form-label">{{ $t("accounts.amount") }}</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="deposit.amount"
                  class="form-control"
                  placeholder="Amount"
                />
                <div class="input-group-text">{{ settings.currency }}</div>
              </div>
            </div>
            <div class="col-12 text-center mt-12">
              <button
                class="btn btn-success me-2"
                type="button"
                @click="DepositAlert"
              >
                <i class="ti ti-circle-plus me-1"></i>
                {{ $t("accounts.money.deposit") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="withdrawDialogVisible"
    class="modal fade"
    id="WithdrawModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-danger">
              {{ $t("accounts.money.withdraw") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />

          <form class="row g-4 mt-2" onsubmit="return false">
            <!-- <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("accounts.withdraw_date")
              }}</label>
              <input
                type="datetime-local"
                v-model="withdraw.date"
                class="form-control"
              />
            </div> -->
            <div class="col-12">
              <label class="form-label">{{ $t("accounts.amount") }}</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="withdraw.amount"
                  class="form-control"
                />
                <div class="input-group-text">{{ settings.currency }}</div>
              </div>
            </div>
            <div class="col-12 text-center mt-12">
              <button
                class="btn btn-danger me-2"
                type="button"
                @click="WithdrawAlert"
              >
                <i class="ti ti-circle-minus me-1"></i>
                {{ $t("accounts.money.withdraw") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="addSalesModal" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            id="add-sale-close"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-success">
              {{ $t("sales.add_sales") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />

          <form class="row g-4 mt-2" onsubmit="return false">
            <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("accounts.username")
              }}</label>
              <input
                type="text"
                disabled
                v-model="account.username"
                class="form-control"
              />
            </div>
            <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("sales.name")
              }}</label>
              <input type="text" v-model="sale.name" class="form-control" />
            </div>
            <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("sales.description")
              }}</label>
              <input
                type="text"
                v-model="sale.description"
                class="form-control"
              />
            </div>
            <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("sales.notes")
              }}</label>
              <input type="text" v-model="sale.notes" class="form-control" />
            </div>
            <div class="col-12">
              <label class="form-label" for="price">{{
                $t("sales.price")
              }}</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="sale.price"
                  class="form-control"
                />
                <div class="input-group-text">{{ settings.currency }}</div>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="paid">{{
                $t("sales.paid")
              }}</label>
              <div class="input-group">
                <input type="number" v-model="sale.paid" class="form-control" />
                <div class="input-group-text">{{ settings.currency }}</div>
              </div>
            </div>
            <div class="col-12 text-center mt-12">
              <button
                class="btn btn-success me-2"
                type="button"
                @click="storeSale"
              >
                <i class="ti ti-circle-plus me-1"></i>
                {{ $t("control.add") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <SalesPay
    v-if="selectedSale"
    :selectedSale="selectedSale"
    @updated="
      selectedSale = null;
      fetchAccount();
    "
  />
  <BillsPay
    v-if="selectedBill"
    :selectedBill="selectedBill"
    @updated="
      selectedBill = null;
      fetchAccount();
    "
  />
  <BillsNotify
    v-if="selectedBill"
    :selectedBill="selectedBill"
    @updated="
      selectedBill = null;
      fetchAccount();
    "
  />

  <!-- modals end -->

  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="row">
      <div class="col-xl-4 col-lg-5 ">
        <div class="card card-border-shadow-primary mb-6">
          <div class="card-body pt-12">
            <div class="user-avatar-section">
              <div class="d-flex align-items-center flex-column">
                <img
                  class="img-fluid rounded mb-4"
                  src="@/assets/img/avatars/1.png"
                  height="120"
                  width="120"
                  alt="User avatar"
                />
                <div class="user-info text-center">
                  <h5 class="mb-0" dir="ltr">{{ account.username }}</h5>
                  <div class="flex gap-x-1">
                    <h5>
                      {{ account.first_name }}
                    </h5>
                    <h5>
                      {{ account.last_name }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex justify-content-around flex-wrap mb-6 gap-0 gap-md-3 gap-lg-4"
            >
              <div class="row gap-y-1">
                <div class="d-flex align-items-center col-md-6 gap-4">
                  <div class="avatar">
                    <div class="avatar-initial bg-label-primary rounded">
                      <i class="ti ti-user ti-lg"></i>
                    </div>
                  </div>
                  <div>
                    <span>{{ $t("accounts.username") }}</span>
                    <h5 class="mb-0" dir="ltr">{{ account.username }}</h5>
                  </div>
                </div>
                <div class="d-flex align-items-center col-md-6 gap-4">
                  <div class="avatar">
                    <div class="avatar-initial bg-label-info rounded">
                      <i class="ti ti-brand-speedtest ti-lg"></i>
                    </div>
                  </div>
                  <div>
                    <span>{{ $t("accounts.profile") }}</span>
                    <h5
                      v-if="hasPrivilege('profiles_edit_profiles')"
                      class="mb-0"
                    >
                      <a
                        :href="`/profiles?profile_id=${account.profile.id}`"
                        class="mb-0 cursor-pointer text-primary"
                        @click.prevent="
                          $router.push({
                            path: '/profiles',
                            query: { profile_id: account.profile.id },
                          })
                        "
                      >
                        {{ account.profile.name }}
                      </a>
                    </h5>
                    <h5 class="mb-0" v-else dir="ltr">
                      {{ account.profile.name }}
                    </h5>
                  </div>
                </div>
                <div class="d-flex align-items-center col-md-6 gap-4">
                  <div class="avatar">
                    <div
                      class="avatar-initial rounded"
                      :class="{
                        'bg-label-success': account.online,
                        'bg-label-danger': !account.online,
                      }"
                    >
                      <i class="ti ti-wifi ti-lg"></i>
                    </div>
                  </div>
                  <div>
                    <span>{{ $t("accounts.status") }}</span>
                    <h5 v-if="!account.active" class="mb-0">
                      {{ $t("control.expired") }}
                    </h5>
                    <h5 v-else class="mb-0">
                      {{
                        account.online
                          ? $t("control.online")
                          : $t("control.offline")
                      }}
                    </h5>
                  </div>
                </div>
                <div class="d-flex align-items-center col-md-6 gap-4">
                  <div class="avatar">
                    <div class="avatar-initial bg-label-warning rounded">
                      <i class="ti ti-calendar-cancel ti-lg"></i>
                    </div>
                  </div>
                  <div v-if="account.profile.has_expiration">
                    <span>{{ $t("accounts.expiration") }}</span>
                    <h5 class="mb-0">
                      {{ account.expires_at_diff_human }}
                    </h5>
                    <span class="mb-0 text-xs">
                      {{ formatDateHours(account.expires_at) }}
                    </span>
                    <span
                      class="mb-0 text-xs text-primary font-bold"
                      v-if="account.wait_days"
                    >
                      +{{ account.wait_days }}
                    </span>
                  </div>
                  <div v-else>{{ $t("control.unlimited") }}</div>
                </div>
                <div
                  v-if="hasPrivilege('accounts_view_accounts_shamcash')"
                  class="d-flex align-items-center col-md-12 gap-4"
                >
                  <div class="avatar">
                    <div class="avatar-initial rounded">
                      <img src="@/assets/sham_logo.png" alt="" />
                    </div>
                  </div>
                  <div>
                    <span>{{ $t("accounts.shamcash_code") }}</span>
                    <h5
                      class="mb-0 cursor-pointer"
                      id="shamcash_code"
                      dir="ltr"
                      @click="copyToClip(account.shamcash_code)"
                      :title="$t('control.click_to_copy')"
                    >
                      {{ account.shamcash_code }}
                    </h5>
                    <!-- <span class="mb-0 text-xs">
                      {{ formatDateHours(account.expires_at) }}
                    </span> -->
                  </div>
                </div>
              </div>
            </div>
            <h5 class="pb-4 border-bottom mb-4">
              {{ $t("accounts.details") }}
            </h5>
            <div class="info-container">
              <ul class="list-unstyled mb-6">
                <li class="mb-3">
                  <span class="h6"
                    ><i class="ti ti-id me-2"></i
                    >{{ $t("accounts.national_id") }}:</span
                  >
                  <span class="mx-1">{{ account.national_id }}</span>
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="ti ti-man me-2"></i
                    >{{ $t("accounts.father_name") }}:</span
                  >
                  <span class="mx-1">{{ account.father_name }}</span>
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="ti ti-woman me-2"></i
                    >{{ $t("accounts.mother_name") }}:</span
                  >
                  <span class="mx-1">{{ account.mother_name }}</span>
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="ti ti-device-mobile me-2"></i
                    >{{ $t("accounts.phone") }}:</span
                  >
                  <a
                    class="mx-1"
                    dir="ltr"
                    v-if="account.whatsapp_url"
                    @click.prevent="
                      openTab(`https://wa.me/${account.whatsapp_url}`)
                    "
                    :href="`https://wa.me/${account.phone}`"
                    >{{ account.phone }}</a
                  >
                  <span v-else class="mx-1" dir="ltr">{{ account.phone }}</span>
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="ti ti-mail me-2"></i
                    >{{ $t("accounts.email") }}:</span
                  >
                  <span class="mx-1">{{ account.email }}</span>
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="ti ti-map-pin me-2"></i
                    >{{
                      this.$store.getters.settings.center == 1
                        ? "رقم البوابة"
                        : $t("accounts.address")
                    }}:</span
                  >
                  <span class="mx-1">{{
                    account.country +
                      ", " +
                      account.state +
                      ", " +
                      account.city +
                      ", " +
                      account.neighborhood +
                      ", " +
                      account.street
                  }}</span>
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="ti ti-world-pin me-2"></i
                    >{{ $t("accounts.map_coordinates") }}:</span
                  >
                  <span class="mx-1"
                    >{{ account.latitude }} , {{ account.longitude }}</span
                  >
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="ti ti-phone me-2"></i
                    >{{ $t("accounts.phone_line") }}:</span
                  >
                  <span class="mx-1">{{ account.phone_line }}</span>
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="ti ti-note me-2"></i
                    >{{ $t("accounts.notes") }}:</span
                  >
                  <span class="mx-1">{{ account.notes }}</span>
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="me-2 ti ti-receipt text-success"></i
                    >{{ $t("accounts.total_paid") }}:</span
                  >
                  <span class="mx-1">{{ account.paid }}</span>
                </li>
                <li class="mb-3">
                  <span class="h6"
                    ><i class="me-2 ti ti-receipt text-danger"></i
                    >{{ $t("accounts.debts") }}:</span
                  >
                  <span
                    class="mx-1 underline cursor-pointer"
                    @click="
                      account_bills = account.bills.filter(
                        (bill) => bill.price > bill.paid,
                      );
                      account_bills.filter_value = 'debt';
                      setActiveTab('tab-bills');
                    "
                    >{{ account.debt }}</span
                  >
                </li>
                <li class="mb-3" v-if="account.active_sessions.length > 0">
                  <span class="h6"
                    ><i class="ti ti-wifi text-success me-2"></i
                    >{{ $t("control.online") }}:</span
                  >
                  <span
                    class="mx-1"
                    v-for="(session, index) in account.active_sessions"
                    :key="index"
                  >
                    (<span v-if="session.nas" class="text-sm">{{
                      session.nas.shortname
                    }}</span>
                    <a
                      :href="`http://${session.framedipaddress}`"
                      target="_blank"
                      @click.prevent="
                        openTab(`http://${session.framedipaddress}`)
                      "
                    >
                      {{ session.framedipaddress }} </a
                    >)
                  </span>
                </li>
                <li class="mb-3" v-if="account.active_sessions.length == 0">
                  <span class="h6"
                    ><i class="ti ti-wifi-off text-danger me-2"></i
                    >{{ $t("control.offline") }}</span
                  >
                </li>
                <li class="mb-3" v-if="account.last_connect">
                  <span class="h6"
                    ><i class="ti ti-wifi text-success me-2"></i
                    >{{ $t("accounts.last_connect_time") }}:</span
                  >
                  <span class="mx-1">
                    {{ formatDateHours(account.last_connect) }}
                  </span>
                </li>
              </ul>

              <div class="row">
                <div class="col-12 mt-3">
                  <div class="d-grid w-100">
                    <button
                      type="button"
                      class="btn btn-primary"
                      data-bs-target="#editUser"
                      data-bs-toggle="modal"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                    >
                      <i class="ti ti-edit me-2"></i>
                      {{ $t("accounts.edit_general_information") }}
                    </button>
                  </div>
                </div>

                <div
                  class="col-12 mt-6"
                  v-if="hasPrivilege('accounts_disable_accounts')"
                >
                  <div class="d-grid w-100">
                    <button
                      v-if="account.enabled == 1"
                      type="button"
                      class="btn btn-warning"
                      @click="deactivateAccount"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                    >
                      <i class="ti ti-shield-off me-2"></i>
                      {{ $t("accounts.deactivate_account") }}
                    </button>
                    <button
                      v-if="account.enabled == 0"
                      type="button"
                      class="btn btn-success"
                      @click="activateAccount"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                    >
                      <i class="ti ti-shield me-2"></i>
                      {{ $t("accounts.reactivate_account") }}
                    </button>
                  </div>
                </div>

                <div
                  class="col-12 mt-3 mb-3"
                  v-if="hasPrivilege('accounts_delete_accounts')"
                >
                  <div class="d-grid w-100">
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="confirmDeleteAccount"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                    >
                      <i class="ti ti-trash me-2"></i>
                      {{ $t("accounts.delete_account_permanently") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8 col-lg-7">
        <div class="nav-align-top">
          <ul class="nav nav-pills flex-column flex-md-row mb-4 row-gap-2">
            <li class="nav-item" v-for="tab in tabs" :key="tab.id">
              <a
                class="nav-link"
                href="javascript:void(0);"
                :class="{ active: activeTab === tab.id }"
                @click="setActiveTab(tab.id)"
              >
                <i :class="tab.icon + ' me-2 ti-sm'"></i>
                {{ tab.label }}
              </a>
            </li>
          </ul>
        </div>

        <div v-show="activeTab === 'tab-subscription'" class="tab-content-box">
          <div
            class="card mb-6 border border-2 border-primary rounded primary-shadow"
          >
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start">
                <div class="d-flex justify-content-center">
                  <h2 class="mb-0 text-primary">
                    {{ formatSpeed(account.profile.download_rate_kb) }}
                  </h2>
                </div>
                <div class="d-flex justify-content-center">
                  <sub class="h5 pricing-currency mb-auto mt-1 text-primary">{{
                    settings.currency
                  }}</sub>
                  <h2 class="mb-0 text-primary">{{ account.profile.price }}</h2>
                  <sub class="h6 pricing-duration mt-auto mb-3 fw-normal">{{
                    $t(`accounts.unit.${account.profile.expiration_unit}`)
                  }}</sub>
                </div>
              </div>
              <div v-if="account.profile.has_expiration">
                <div
                  class="d-flex justify-content-between align-items-center mb-1"
                >
                  <span class="h6 mb-0">{{ $t("control.days") }}</span>
                  <span class="h6 mb-0">{{
                    $t("accounts.days_of", {
                      days:
                        account.expires_at_diff > 0
                          ? account.renew_at_diff - account.expires_at_diff
                          : 0,
                      total: account.renew_at_diff,
                    })
                  }}</span>
                </div>
                <div
                  v-if="account.expires_at_diff > 0"
                  class="progress mb-1 bg-label-primary"
                  style="height: 6px"
                >
                  <div
                    class="progress-bar"
                    role="progressbar"
                    :style="{
                      width: `${parseFloat(
                        ((account.renew_at_diff - account.expires_at_diff) *
                          100) /
                          account.renew_at_diff,
                      ).toFixed(0)}%`,
                    }"
                    aria-valuenow="65"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div v-else class="progress mb-1 bg-label-primary">
                  <div
                    class="progress-bar bg-danger"
                    role="progressbar"
                    style=" width: 100%;"
                    aria-valuenow="65"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <small v-if="account.expires_at_diff >= 0">{{
                  account.expires_at_diff + " " + $t("accounts.days_remaining")
                }}</small>
                <small v-else>{{
                  Math.abs(account.expires_at_diff) +
                    " " +
                    $t("accounts.days_expired")
                }}</small>
              </div>
              <div v-else>
                <small>{{ $t("control.unlimited") }}</small>
              </div>
              <!-- QUOTA PROGRESS -->
              <div
                v-if="account.profile.traffic_limited"
                class="d-flex justify-content-between align-items-start mt-4"
              >
                <div class="d-flex justify-content-center">
                  <h2 class="mb-0 text-primary">
                    {{ formatTrafficMB(account.allowed_quota_mb) }}
                  </h2>
                </div>
              </div>
              <div
                v-if="account.profile.traffic_limited"
                class="d-flex justify-content-between align-items-center mb-1"
              >
                <span class="h6 mb-0">MB</span>
                <span class="h6 mb-0">{{
                  $t("accounts.mega_of", {
                    used: account.used_quota_mb,
                    total: account.allowed_quota_mb,
                  })
                }}</span>
              </div>
              <div
                v-if="account.profile.traffic_limited"
                class="progress mb-1 bg-label-primary"
                style="height: 6px"
              >
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{
                    width: `${parseFloat(
                      (account.used_quota_mb * 100) / account.allowed_quota_mb,
                    ).toFixed(0)}%`,
                  }"
                  :class="{
                    'bg-danger':
                      account.used_quota_mb >= account.allowed_quota_mb,
                  }"
                  aria-valuenow="65"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <small
                v-if="
                  account.profile.traffic_limited &&
                    account.used_quota_mb >= account.allowed_quota_mb
                "
                >{{ $t("accounts.traffic_limit_reached") }}</small
              >
              <div class="row">
                <div
                  class="col-md-6"
                  v-if="
                    hasPrivilege('accounts_edit_accounts') ||
                      hasPrivilege('accounting_pay_bill') ||
                      hasPrivilege('accounts_renew_accounts')
                  "
                >
                  <div class="d-grid w-100 mt-4">
                    <button
                      class="btn btn-primary"
                      @click="showRenewDialog"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                    >
                      <i class="ti ti-refresh ti-xs me-2"></i>
                      <span>{{ $t("accounts.renew_subscription") }}</span>
                    </button>
                  </div>
                </div>

                <div
                  v-if="hasPrivilege('accounts_auto_renew_accounts')"
                  class="col-md-6"
                >
                  <div class="d-grid w-100 mt-4">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-info dropdown-toggle"
                        :class="{
                          disabled_ssr: !this.$store.getters.settings.license
                            .active,
                        }"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="ti ti-reload ti-xs me-2"></i>
                        <span v-if="account.auto_renew == 0"
                          >{{ $t("accounts.renew_type") }} ({{
                            $t("control.manual")
                          }})</span
                        >
                        <span v-if="account.auto_renew == 1"
                          >{{ $t("accounts.renew_type") }} ({{
                            $t("control.auto")
                          }})</span
                        >
                      </button>
                      <ul class="dropdown-menu w-100">
                        <li>
                          <a
                            type="button"
                            class="dropdown-item"
                            @click="confirmRenewManual"
                            >{{ $t("control.manual") }}</a
                          >
                        </li>
                        <li>
                          <a
                            type="button"
                            class="dropdown-item"
                            @click="confirmRenewAuto"
                            >{{ $t("control.auto") }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div v-if="hasPrivilege('accounts_renew_48')" class="col-md-6">
                  <div class="d-grid w-100 mt-4">
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="confirmAdd2TempDays"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                    >
                      <i class="ti ti-calendar-plus ti-xs me-2"></i>
                      <span>{{ $t("accounts.add_2_temp_days") }}</span>
                    </button>
                  </div>
                </div>

                <div v-if="hasPrivilege('accounts_renew_72')" class="col-md-6">
                  <div class="d-grid w-100 mt-4">
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="confirmAdd3TempDays"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                    >
                      <i class="ti ti-calendar-plus ti-xs me-2"></i>
                      <span>{{ $t("accounts.add_3_temp_days") }}</span>
                    </button>
                  </div>
                </div>

                <div
                  v-if="hasPrivilege('accounts_renew_48_free')"
                  class="col-md-6"
                >
                  <div class="d-grid w-100 mt-4">
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="confirmAdd2FreeDays"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                    >
                      <i class="ti ti-calendar-plus ti-xs me-2"></i>
                      <span>{{ $t("accounts.add_2_free_days") }}</span>
                    </button>
                  </div>
                </div>

                <div
                  class="col-md-6"
                  v-if="hasPrivilege('accounts_temp_speed_accounts')"
                >
                  <div class="d-grid w-100 mt-4">
                    <button
                      class="btn btn-warning"
                      data-bs-target="#tempSpeedModal"
                      data-bs-toggle="modal"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                    >
                      <i class="ti ti-gauge ti-xs me-2"></i>
                      <span>{{ $t("accounts.temporary_speed_change") }}</span>
                    </button>
                  </div>
                </div>

                <div
                  class="col-md-6"
                  v-if="hasPrivilege('accounts_disconnect_accounts')"
                >
                  <div class="d-grid w-100 mt-4">
                    <button
                      class="btn btn-danger waves-effect waves-light"
                      :class="{
                        disabled_ssr: !this.$store.getters.settings.license
                          .active,
                      }"
                      @click="confirmDisconnect"
                    >
                      <span>
                        <i class="ti ti-wifi-off ti-xs me-2"></i>
                        <span>{{ $t("accounts.disconnect") }}</span>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card mb-6 h-100">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div
                    class="alert alert-dark d-flex align-items-center"
                    role="alert"
                  >
                    <span class="alert-icon rounded me-2">
                      <i class="ti ti-hash"></i>
                    </span>
                    {{ $t("accounts.serial_number") }}:
                    <strong class="ms-2">{{ account.serial_number }}</strong>
                  </div>
                </div>

                <div class="col-md-4">
                  <div
                    class="alert alert-dark d-flex align-items-center"
                    role="alert"
                  >
                    <span class="alert-icon rounded me-2">
                      <i class="ti ti-at"></i>
                    </span>
                    {{ $t("accounts.username") }}:
                    <strong dir="ltr" class="ms-2">{{
                      account.username
                    }}</strong>
                  </div>
                </div>

                <div class="col-md-4">
                  <div
                    class="alert alert-dark d-flex align-items-center"
                    role="alert"
                  >
                    <span class="alert-icon rounded me-2">
                      <i class="ti ti-lock"></i>
                    </span>
                    {{ $t("accounts.password") }}:
                    <!-- <strong class="ms-2">{{ account.password }}</strong> -->
                    <strong
                      v-if="hasPrivilege('accounts_view_accounts_passwords')"
                      class="ms-2"
                      >{{ account.password }}</strong
                    >
                    <strong v-else class="ms-2">******</strong>
                  </div>
                </div>

                <div
                  class="col-md-4"
                  v-if="hasPrivilege('accounts_reseller_accounts')"
                >
                  <div
                    class="alert alert-dark d-flex align-items-center"
                    role="alert"
                  >
                    <span class="alert-icon rounded me-2">
                      <i class="ti ti-user-shield"></i>
                    </span>
                    {{ $t("accounts.reseller") }}:
                    <strong class="ms-2">{{ account.reseller_id }}</strong>
                  </div>
                </div>

                <div class="col-md-4">
                  <div
                    class="alert alert-dark d-flex align-items-center"
                    role="alert"
                  >
                    <span class="alert-icon rounded me-2">
                      <i class="ti ti-device-laptop"></i>
                    </span>
                    {{ $t("accounts.allowed_devices") }}:
                    <strong class="ms-2">{{ account.allowed_sessions }}</strong>
                  </div>
                </div>
                <div class="col-md-4">
                  <div
                    class="alert alert-dark d-flex align-items-center"
                    role="alert"
                  >
                    <span class="alert-icon rounded me-2">
                      <i class="ti ti-package"></i>
                    </span>
                    {{ $t("accounts.short.next_profile") }}:
                    <strong class="ms-2">{{
                      account.next_profile_name
                    }}</strong>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div
                    class="alert alert-dark d-flex align-items-center"
                    role="alert"
                  >
                    <span class="alert-icon rounded me-2">
                      <i class="tf-icons ti ti-topology-star-ring-3"></i>
                    </span>
                    {{ $t("accounts.private_ip_address") }}:
                    <strong class="ms-2" v-if="account.private_ip">{{
                      account.private_ip.ip_address
                    }}</strong>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="alert alert-dark d-flex align-items-center"
                    role="alert"
                  >
                    <span class="alert-icon rounded me-2">
                      <i class="ti ti-device-laptop"></i>
                    </span>
                    {{ $t("accounts.mac_address") }}:
                    <strong class="ms-2">{{ account.mac_address }}</strong>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="alert alert-dark d-flex align-items-center"
                    role="alert"
                  >
                    <span class="alert-icon rounded me-2">
                      <i class="tf-icons ti ti-topology-star-ring-3"></i>
                    </span>
                    {{ $t("accounts.public_ip_address") }}:
                    <strong
                      dir="ltr"
                      class="ms-2"
                      v-if="account.public_ip_port"
                      >{{
                        account.public_ip_port.ip_address +
                          ":" +
                          account.public_ip_port.start +
                          "->" +
                          account.public_ip_port.end
                      }}</strong
                    >
                  </div>
                </div>
              </div>

              <div class="d-grid w-100 mt-4">
                <button
                  v-if="
                    hasPrivilege('accounts_edit_username_accounts') ||
                      hasPrivilege('accounts_edit_password_accounts') ||
                      hasPrivilege('accounts_edit_profile_accounts') ||
                      hasPrivilege('accounts_edit_expiration_accounts') ||
                      hasPrivilege('accounts_reseller_accounts')
                  "
                  class="btn btn-primary"
                  data-bs-target="#editAccountD"
                  data-bs-toggle="modal"
                  :class="{
                    disabled_ssr: !this.$store.getters.settings.license.active,
                  }"
                >
                  <i class="ti ti-edit ti-xs me-2"></i>
                  <span>{{ $t("accounts.edit_account_details") }}</span>
                </button>
              </div>
            </div>
          </div>
          <div
            class="card mb-6 h-100"
            v-if="this.$store.getters.settings.type == 'local'"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <div>
                <h4 class="mb-1">{{ $t("accounts.national_id_image") }}</h4>
              </div>
            </div>
            <div class="card-body flex flex-col">
              <div
                class="flex flex-col items-center"
                v-if="account.nid_image_front_url"
              >
                <span class="h6 border-bottom">{{
                  $t("accounts.front_side")
                }}</span>
                <img
                  :src="account.nid_image_front_url"
                  :alt="account.username"
                  style="max-height: 30rem;"
                  class="mb-4"
                />
              </div>
              <div
                class="flex flex-col items-center"
                v-if="account.nid_image_back_url"
              >
                <span class="h6 border-bottom">{{
                  $t("accounts.rear_side")
                }}</span>
                <img
                  :src="account.nid_image_back_url"
                  :alt="account.username"
                  style="max-height: 30rem;"
                  class="mb-4"
                />
              </div>
            </div>
          </div>
          <div class="card mb-6 h-100">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <div>
                <h4 class="mb-1">{{ $t("accounts.location") }}</h4>
              </div>
            </div>

            <div class="card-body" style="height: 580px;">
              <!-- <GMapMap
                class="google-map"
                :center="{
                  lat: account.latitude ?? 36.185155536944286,
                  lng: account.longitude ?? 36.72103984597841,
                }"
                :zoom="14"
                @click="onMapClick"
              >
                <GMapMarker
                  v-if="account.latitude && account.longitude"
                  :position="{ lat: account.latitude, lng: account.longitude }"
                  :icon="{
                    url: require('@/assets/img/map/1.svg'),
                    scaledSize: { width: 80, height: 80 },
                  }"
                />
              </GMapMap> -->
              <l-map
                ref="map"
                style="height: 400px;"
                v-model:zoom="zoom"
                :center="[
                  account.latitude ?? 36.185155536944286,
                  account.longitude ?? 36.72103984597841,
                ]"
                @click="onMapClick"
              >
                <l-tile-layer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  layer-type="base"
                  name="OpenStreetMap"
                ></l-tile-layer>
                <l-marker
                  v-if="account.latitude && account.longitude"
                  :lat-lng="[account.latitude, account.longitude]"
                >
                  <l-icon
                    :icon-url="account_icon_url"
                    :icon-size="[80, 80]"
                  ></l-icon>
                </l-marker>
              </l-map>
              <div class="alert alert-dark d-flex align-items-center mt-3">
                <span class="alert-icon rounded me-2">
                  <i class="ti ti-map-pin"></i>
                </span>
                {{ $t("accounts.map_coordinates") }}:
                <strong class="ms-2">{{
                  account.latitude + ", " + account.longitude
                }}</strong>
                <div
                  v-if="
                    !edit_location &&
                      hasPrivilege('accounts_edit_personal_accounts')
                  "
                  @click="edit_location = true"
                  :class="{
                    disabled_ssr: !this.$store.getters.settings.license.active,
                  }"
                  class="btn btn-primary ms-auto"
                >
                  <span class="ti ti-edit"></span>
                  <div>{{ $t("accounts.edit_location") }}</div>
                </div>
                <div v-if="edit_location">
                  {{ $t("maps.click_on_map_to_add_marker") }}
                </div>
                <div
                  v-if="edit_location"
                  @click="edit_location = false"
                  class="btn btn-danger ms-auto"
                >
                  <span class="mx-1">X</span>
                  <div>{{ $t("accounts.edit_location") }}</div>
                </div>
              </div>
              <a
                v-if="account.latitude && account.longitude"
                class="btn btn-primary mx-1 w-100"
                :href="
                  `https://www.google.com/maps?q=${account.latitude},${account.longitude}`
                "
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ this.$t("accounts.open_in_google_maps") }}
              </a>
            </div>
          </div>
        </div>

        <div
          v-show="activeTab === 'tab-bills'"
          v-if="hasPrivilege('accounts_bills_accounts')"
          class="tab-content-box"
        >
          <div
            v-if="hasPrivilege('accounts_money_accounts')"
            class="card card-border-shadow-primary mb-5 p-4"
          >
            <div
              class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3"
            >
              <div>
                <span class="badge bg-label-primary p-2 fs-6">
                  {{ $t("accounts.money.current_balance") }}:
                  <strong>{{ account.money + settings.currency }}</strong>
                </span>
              </div>

              <div>
                <button
                  class="btn btn-success me-2"
                  @click.prevent="showDepositDialog"
                  :class="{
                    disabled_ssr: !this.$store.getters.settings.license.active,
                  }"
                >
                  <i class="ti ti-circle-plus me-1"></i>
                  {{ $t("accounts.money.deposit") }}
                </button>
                <button
                  class="btn btn-danger"
                  @click.prevent="showWithdrawDialog"
                  :class="{
                    disabled_ssr: !this.$store.getters.settings.license.active,
                  }"
                >
                  <i class="ti ti-circle-minus me-1"></i>
                  {{ $t("accounts.money.withdraw") }}
                </button>
              </div>
            </div>
          </div>
          <div class="card mb-2">
            <div class="card-datatable">
              <div class="dataTables_wrapper dt-bootstrap5 no-footer">
                <div class="row mx-1" bis_skin_checked="1">
                  <div
                    class="col-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0 "
                    bis_skin_checked="1"
                  >
                    <button
                      class="btn"
                      :class="{
                        'btn-primary':
                          account_bills.filter_value != 'debt' &&
                          account_bills.filter_value != 'paid',
                        'btn-outline-primary':
                          account_bills.filter_value == 'debt' ||
                          account_bills.filter_value == 'paid',
                      }"
                      @click="account_bills = account.bills"
                    >
                      عرض الكل
                    </button>
                    <button
                      class="btn"
                      :class="{
                        'btn-outline-danger':
                          account_bills.filter_value != 'debt',
                        'btn-danger': account_bills.filter_value == 'debt',
                      }"
                      @click="
                        account_bills = account.bills.filter(
                          (bill) => bill.price > bill.paid,
                        );
                        account_bills.filter_value = 'debt';
                      "
                    >
                      الديون
                    </button>
                    <button
                      class="btn"
                      :class="{
                        'btn-outline-success':
                          account_bills.filter_value != 'paid',
                        'btn-success': account_bills.filter_value == 'paid',
                      }"
                      @click="
                        account_bills = account.bills.filter(
                          (bill) => bill.price <= bill.paid,
                        );
                        account_bills.filter_value = 'paid';
                      "
                    >
                      المدفوعات
                    </button>
                  </div>
                  <div
                    class="col-12 col-md-5 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
                    bis_skin_checked="1"
                  >
                    <div
                      id="DataTables_Table_0_filter"
                      class="dataTables_filter"
                      bis_skin_checked="1"
                    >
                      <label>
                        <input
                          type="search"
                          class="form-control"
                          :placeholder="$t('control.search')"
                          aria-controls="DataTables_Table_0"
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row mx-1 mt-n6" bis_skin_checked="1">
                  <div
                    class="col-12 col-md-9 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dataTables_length"
                      id="DataTables_Table_0_length"
                      bis_skin_checked="1"
                    >
                      <label
                        >{{ $t("control.show") }}
                        <select
                          name="DataTables_Table_0_length"
                          aria-controls="DataTables_Table_0"
                          class="form-select"
                          v-model="filters.bills_rows"
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </label>
                    </div>
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <!-- <div
                        class="dt-buttons btn-group flex-wrap"
                        bis_skin_checked="1"
                      >
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#bills-columns"
                          class="btn btn-secondary  waves-effect waves-light"
                          tabindex="0"
                          aria-controls="DataTables_Table_0"
                          type="button"
                        >
                          <span>
                            <i class="ti ti-scan-eye ti-s me-md-2"></i>
                            <span class="d-md-inline-block d-none"
                              >{{ $t('control.columns_visible') }}</span
                            >
                          </span>
                        </button>
                      </div> -->
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-3 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <div class="btn-group" id="dropdown-icon-demo">
                        <button
                          type="button"
                          class="btn btn-info dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i class="ti ti-upload ti-xs me-2"></i>
                          {{ $t("control.export") }}
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-printer me-2"></i>Print</a
                            >
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-file me-2"></i>Csv</a
                            >
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-file-export me-2"></i>Excel</a
                            >
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-file-text me-2"></i>Pdf</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dataTables_scroll" bis_skin_checked="1">
                  <div
                    class="dataTables_scrollBody table-container"
                    bis_skin_checked="1"
                    style="position: relative; overflow: auto; width: 100%; height: 440px;"
                  >
                    <table
                      class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                      id="DataTables_Table_0"
                      aria-describedby="DataTables_Table_0_info"
                    >
                      <thead>
                        <tr class="text-nowrap">
                          <th>
                            <!-- <div
                              v-if="selectedItemsCount(account.bills) > 1"
                              class="dropdown"
                            >
                              <button
                                type="button"
                                class="btn p-0 dropdown-toggle hide-arrow"
                                data-bs-toggle="dropdown"
                              >
                                <i class="ti ti-dots-vertical"></i>
                              </button>
                              <ul class="dropdown-menu">
                                <li>
                                  <a
                                    class="dropdown-item text-primary"
                                    href="#"
                                  >
                                    <i class="ti ti-printer me-2"></i>Print
                                  </a>
                                </li>
                                <li>
                                  <a class="dropdown-item text-danger" href="#">
                                    <i class="ti ti-trash me-2"></i>Delete
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item text-warning"
                                    href="#"
                                  >
                                    <i class="ti ti-bell me-2"></i>Notify
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item text-success"
                                    href="#"
                                  >
                                    <i class="ti ti-cash me-2"></i>Pay
                                  </a>
                                </li>
                              </ul>
                            </div> -->
                          </th>
                          <th>
                            <input
                              class="form-check-input"
                              :value="account_bills.allSelected"
                              @input="toggleAllSelected(account_bills)"
                              type="checkbox"
                            />
                          </th>
                          <th>#</th>
                          <th>{{ $t("bills.slug") }}</th>
                          <th>{{ $t("bills.admin") }}</th>
                          <th>{{ $t("accounts.profile") }}</th>
                          <th>{{ $t("bills.price") }}</th>
                          <th>{{ $t("bills.paid") }}</th>
                          <th>{{ $t("bills.from") }}</th>
                          <th>{{ $t("bills.to") }}</th>
                          <th>{{ $t("bills.notes") }}</th>
                          <th>{{ $t("bills.invoice.issued_date") }}</th>
                          <th>{{ $t("bills.invoice.updated_at") }}</th>
                        </tr>
                      </thead>
                      <tbody class="table-border-bottom-0 ">
                        <tr
                          v-for="bill in account_bills.slice(
                            0,
                            filters.bills_rows,
                          )"
                          :key="bill.id"
                          :class="{
                            'bg-label-danger2': bill.paid < bill.price,
                          }"
                        >
                          <td>
                            <div
                              v-if="selectedItemsCount(account_bills) <= 1"
                              class="dropdown"
                            >
                              <button
                                type="button"
                                class="btn p-0 dropdown-toggle hide-arrow"
                                data-bs-toggle="dropdown"
                              >
                                <i class="ti ti-dots-vertical"></i>
                              </button>
                              <ul
                                class="dropdown-menu"
                                :class="{
                                  disabled_ssr: !this.$store.getters.settings
                                    .license.active,
                                }"
                              >
                                <li>
                                  <a
                                    class="dropdown-item text-primary"
                                    href="#"
                                    @click="
                                      selectedBill = bill;
                                      printBill(bill);
                                    "
                                  >
                                    <i class="ti ti-printer me-2"></i
                                    >{{ $t("actions.print") }}
                                  </a>
                                </li>
                                <li
                                  v-if="
                                    (bill.today ||
                                      (this.user.type == 'sysadmin' &&
                                        this.$store.getters.settings.center !=
                                          1)) &&
                                      hasPrivilege('accounting_delete_bills')
                                  "
                                >
                                  <a
                                    class="dropdown-item text-danger"
                                    @click="deleteBill(bill)"
                                    href="#"
                                  >
                                    <i class="ti ti-trash me-2"></i
                                    >{{ $t("actions.delete") }}
                                  </a>
                                </li>
                                <li
                                  v-if="
                                    bill.price > bill.paid &&
                                      hasPrivilege(
                                        'notifications_push_notifications',
                                      )
                                  "
                                >
                                  <a
                                    class="dropdown-item text-warning"
                                    href="#"
                                    @click="showNotifyBillDialog(bill)"
                                  >
                                    <i class="ti ti-bell me-2"></i
                                    >{{ $t("bills.notify") }}
                                  </a>
                                </li>
                                <li
                                  v-if="
                                    hasPrivilege('accounting_pay_bill') &&
                                      bill.price > bill.paid
                                  "
                                >
                                  <a
                                    class="dropdown-item text-success"
                                    @click.prevent="showPayBillDialog(bill)"
                                    href="#"
                                  >
                                    <i class="ti ti-cash me-2"></i
                                    >{{ $t("bills.pay") }}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          <td scope="row">
                            <input
                              class="form-check-input"
                              v-model="bill.selected"
                              type="checkbox"
                            />
                          </td>
                          <td>{{ bill.id }}</td>
                          <td>{{ bill.slug }}</td>
                          <td>{{ bill.user_email }}</td>
                          <td>{{ bill.profile_name }}</td>
                          <td>
                            <span class="badge bg-label-primary">{{
                              bill.price + settings.currency
                            }}</span>
                          </td>
                          <td>
                            <span class="badge bg-label-success">{{
                              bill.paid + settings.currency
                            }}</span>
                          </td>
                          <td>{{ formatDateHours(bill.from) }}</td>
                          <td>{{ formatDateHours(bill.to) }}</td>
                          <td>
                            <img
                              src="@/assets/sham_logo.png"
                              alt=""
                              class="h-12 w-12"
                              v-if="
                                bill.notes != null &&
                                  bill.notes.includes('{sham_cash}')
                              "
                            />
                            <div v-else>{{ bill.notes }}</div>
                          </td>
                          <td>{{ formatDateHours(bill.created_at) }}</td>
                          <td>{{ formatDateHours(bill.updated_at) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-1" bis_skin_checked="1">
                  <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_info"
                      id="DataTables_Table_0_info"
                      role="status"
                      aria-live="polite"
                      bis_skin_checked="1"
                    >
                      {{
                        $t("control.pagination", {
                          from: 1,
                          to: filters.bills_rows,
                          total: account_bills.length,
                        })
                      }}
                    </div>
                  </div>

                  <!-- <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                      id="DataTables_Table_0_paginate"
                      bis_skin_checked="1"
                    >
                      <ul class="pagination">
                        <li
                          class="paginate_button page-item previous disabled"
                          id="DataTables_Table_0_previous"
                        >
                          <a
                            aria-controls="DataTables_Table_0"
                            aria-disabled="true"
                            role="link"
                            data-dt-idx="previous"
                            tabindex="-1"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-left ti-sm"></i>
                          </a>
                        </li>
                        <li class="paginate_button page-item active">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            aria-current="page"
                            data-dt-idx="0"
                            tabindex="0"
                            class="page-link"
                            >1</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="1"
                            tabindex="0"
                            class="page-link"
                            >2</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="2"
                            tabindex="0"
                            class="page-link"
                            >3</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="3"
                            tabindex="0"
                            class="page-link"
                            >4</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="4"
                            tabindex="0"
                            class="page-link"
                            >5</a
                          >
                        </li>
                        <li
                          class="paginate_button page-item next"
                          id="DataTables_Table_0_next"
                        >
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="next"
                            tabindex="0"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-right ti-sm"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="card p-4 mb-2">
            <div class="account-bills-total row g-3">
              <div class="col-md-4">
                <div
                  class="alert alert-primary d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-receipt-2 me-2"></i>
                    <strong>{{ $t("bills.total.current_grand") }}:</strong>
                  </span>
                  <strong>{{
                    account_bills
                      .slice(0, filters.bills_rows)
                      .reduce((sum, item) => sum + item.price, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="alert alert-success d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-cash me-2"></i>
                    <strong>{{ $t("bills.total.current_paid") }}:</strong>
                  </span>
                  <strong>{{
                    account_bills
                      .slice(0, filters.bills_rows)
                      .reduce((sum, item) => sum + item.paid, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="alert alert-danger d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-report-money me-2"></i>
                    <strong>{{ $t("bills.total.current_debt") }}:</strong>
                  </span>
                  <strong>{{
                    account_bills
                      .slice(0, filters.bills_rows)
                      .reduce((sum, item) => sum + item.price, 0) -
                      account_bills
                        .slice(0, filters.bills_rows)
                        .reduce((sum, item) => sum + item.paid, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="card p-4 mb-2">
            <div class="account-bills-total row g-3">
              <div class="col-md-4">
                <div
                  class="alert alert-primary d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-calculator me-2"></i>
                    <strong>{{ $t("bills.total.total_grand") }}:</strong>
                  </span>
                  <strong>{{
                    account.bills.reduce((sum, item) => sum + item.price, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="alert alert-success d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-cash me-2"></i>
                    <strong>{{ $t("bills.total.total_paid") }}:</strong>
                  </span>
                  <strong>{{
                    account.bills.reduce((sum, item) => sum + item.paid, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="alert alert-danger d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-report-money me-2"></i>
                    <strong>{{ $t("bills.total.total_debt") }}:</strong>
                  </span>
                  <strong>{{
                    account.bills.reduce((sum, item) => sum + item.price, 0) -
                      account.bills.reduce((sum, item) => sum + item.paid, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-show="activeTab === 'tab-purchases'"
          v-if="hasPrivilege('accounts_sales_accounts')"
          class="tab-content-box"
        >
          <div class="card mb-2">
            <div class="card-datatable">
              <div class="dataTables_wrapper dt-bootstrap5 no-footer">
                <div class="row mx-1" bis_skin_checked="1">
                  <div
                    class="col-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0 "
                    bis_skin_checked="1"
                  >
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <div
                        class="dt-buttons btn-group flex-wrap"
                        bis_skin_checked="1"
                      >
                        <button
                          class="btn btn-primary waves-effect waves-light"
                          data-bs-toggle="modal"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                          data-bs-target="#addSalesModal"
                        >
                          <span>
                            <i class="ti ti-plus ti-xs me-2"></i>
                            <span>{{ $t("sales.add_sales") }}</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-12 col-md-5 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
                    bis_skin_checked="1"
                  >
                    <div
                      id="DataTables_Table_0_filter"
                      class="dataTables_filter"
                      bis_skin_checked="1"
                    >
                      <label>
                        <input
                          type="search"
                          class="form-control"
                          :placeholder="$t('control.search')"
                          aria-controls="DataTables_Table_0"
                        />
                      </label>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mb-3 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0 "
                    bis_skin_checked="1"
                  >
                    <button
                      class="btn"
                      :class="{
                        'btn-primary':
                          account_sales.filter_value != 'debt' &&
                          account_sales.filter_value != 'paid',
                        'btn-outline-primary':
                          account_sales.filter_value == 'debt' ||
                          account_sales.filter_value == 'paid',
                      }"
                      @click="account_sales = account.sales"
                    >
                      عرض الكل
                    </button>
                    <button
                      class="btn"
                      :class="{
                        'btn-outline-danger':
                          account_sales.filter_value != 'debt',
                        'btn-danger': account_sales.filter_value == 'debt',
                      }"
                      @click="
                        account_sales = account.sales.filter(
                          (sale) => sale.price > sale.paid,
                        );
                        account_sales.filter_value = 'debt';
                      "
                    >
                      الديون
                    </button>
                    <button
                      class="btn"
                      :class="{
                        'btn-outline-success':
                          account_bills.filter_value != 'paid',
                        'btn-success': account_bills.filter_value == 'paid',
                      }"
                      @click="
                        account_bills = account.bills.filter(
                          (bill) => bill.price <= bill.paid,
                        );
                        account_bills.filter_value = 'paid';
                      "
                    >
                      المدفوعات
                    </button>
                  </div>
                </div>
                <div class="row mx-1 mt-n6" bis_skin_checked="1">
                  <div
                    class="col-12 col-md-9 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dataTables_length"
                      id="DataTables_Table_0_length"
                      bis_skin_checked="1"
                    >
                      <label
                        >{{ $t("control.show") }}
                        <select
                          name="DataTables_Table_0_length"
                          aria-controls="DataTables_Table_0"
                          class="form-select"
                          v-model="filters.sales_rows"
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </label>
                    </div>
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <!-- <div
                        class="dt-buttons btn-group flex-wrap"
                        bis_skin_checked="1"
                      >
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#bills-columns"
                          class="btn btn-secondary  waves-effect waves-light"
                          tabindex="0"
                          aria-controls="DataTables_Table_0"
                          type="button"
                        >
                          <span>
                            <i class="ti ti-scan-eye ti-s me-md-2"></i>
                            <span class="d-md-inline-block d-none"
                              >{{ $t('control.columns_visible') }}</span
                            >
                          </span>
                        </button>
                      </div> -->
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-3 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <div class="btn-group" id="dropdown-icon-demo">
                        <button
                          type="button"
                          class="btn btn-info dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i class="ti ti-upload ti-xs me-2"></i>
                          {{ $t("control.export") }}
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-printer me-2"></i>Print</a
                            >
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-file me-2"></i>Csv</a
                            >
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-file-export me-2"></i>Excel</a
                            >
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-file-text me-2"></i>Pdf</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dataTables_scroll" bis_skin_checked="1">
                  <div
                    class="dataTables_scrollBody table-container"
                    bis_skin_checked="1"
                    style="position: relative; overflow: auto; width: 100%; height: 440px;"
                  >
                    <table
                      class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                      id="DataTables_Table_0"
                      aria-describedby="DataTables_Table_0_info"
                    >
                      <thead>
                        <tr class="text-nowrap">
                          <th></th>
                          <th>
                            <input
                              class="form-check-input"
                              :value="account_sales.allSelected"
                              @input="toggleAllSelected(account_sales)"
                              type="checkbox"
                            />
                          </th>
                          <th>{{ $t("sales.id") }}</th>
                          <th>{{ $t("sales.name") }}</th>
                          <th>{{ $t("sales.description") }}</th>
                          <th>{{ $t("sales.notes") }}</th>
                          <th>{{ $t("sales.price") }}</th>
                          <th>{{ $t("sales.paid") }}</th>
                          <th>{{ $t("control.updated_at") }}</th>
                          <th>{{ $t("control.created_at") }}</th>
                        </tr>
                      </thead>
                      <tbody class="table-border-bottom-0 ">
                        <tr
                          v-for="sale in account_sales.slice(
                            0,
                            filters.sales_rows,
                          )"
                          :key="sale.id"
                        >
                          <td>
                            <div
                              v-if="selectedItemsCount(account_sales) <= 1"
                              class="dropdown"
                            >
                              <button
                                type="button"
                                class="btn p-0 dropdown-toggle hide-arrow"
                                data-bs-toggle="dropdown"
                              >
                                <i class="ti ti-dots-vertical"></i>
                              </button>
                              <ul
                                class="dropdown-menu"
                                :class="{
                                  disabled_ssr: !this.$store.getters.settings
                                    .license.active,
                                }"
                              >
                                <li>
                                  <a
                                    class="dropdown-item text-primary"
                                    href="#"
                                  >
                                    <i class="ti ti-printer me-2"></i
                                    >{{ $t("actions.print") }}
                                  </a>
                                </li>
                                <li
                                  v-if="hasPrivilege('accounting_delete_sales')"
                                >
                                  <a
                                    class="dropdown-item text-danger"
                                    @click="deleteSale(sale)"
                                    href="#"
                                  >
                                    <i class="ti ti-trash me-2"></i
                                    >{{ $t("actions.delete") }}
                                  </a>
                                </li>
                                <li
                                  v-if="
                                    hasPrivilege('accounting_pay_sale') &&
                                      sale.price > sale.paid
                                  "
                                >
                                  <a
                                    class="dropdown-item text-success"
                                    @click.prevent="showPaySaleDialog(sale)"
                                    href="#"
                                  >
                                    <i class="ti ti-cash me-2"></i
                                    >{{ $t("bills.pay") }}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          <td scope="row">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                            />
                          </td>
                          <td>{{ sale.id }}</td>
                          <td>{{ sale.name }}</td>
                          <td>{{ sale.description }}</td>
                          <td>{{ sale.notes }}</td>

                          <td>{{ sale.price + settings.currency }}</td>
                          <td>{{ sale.paid + settings.currency }}</td>
                          <td>{{ formatDate(sale.updated_at) }}</td>
                          <td>{{ formatDate(sale.created_at) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-1" bis_skin_checked="1">
                  <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_info"
                      id="DataTables_Table_0_info"
                      role="status"
                      aria-live="polite"
                      bis_skin_checked="1"
                    >
                      {{
                        $t("control.pagination", {
                          from: 1,
                          to: filters.sales_rows,
                          total: account_sales.length,
                        })
                      }}
                    </div>
                  </div>

                  <!-- <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                      id="DataTables_Table_0_paginate"
                      bis_skin_checked="1"
                    >
                      <ul class="pagination">
                        <li
                          class="paginate_button page-item previous disabled"
                          id="DataTables_Table_0_previous"
                        >
                          <a
                            aria-controls="DataTables_Table_0"
                            aria-disabled="true"
                            role="link"
                            data-dt-idx="previous"
                            tabindex="-1"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-left ti-sm"></i>
                          </a>
                        </li>
                        <li class="paginate_button page-item active">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            aria-current="page"
                            data-dt-idx="0"
                            tabindex="0"
                            class="page-link"
                            >1</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="1"
                            tabindex="0"
                            class="page-link"
                            >2</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="2"
                            tabindex="0"
                            class="page-link"
                            >3</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="3"
                            tabindex="0"
                            class="page-link"
                            >4</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="4"
                            tabindex="0"
                            class="page-link"
                            >5</a
                          >
                        </li>
                        <li
                          class="paginate_button page-item next"
                          id="DataTables_Table_0_next"
                        >
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="next"
                            tabindex="0"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-right ti-sm"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="card p-4 mb-2">
            <div class="account-bills-total row g-3">
              <div class="col-md-4">
                <div
                  class="alert alert-primary d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-receipt-2 me-2"></i>
                    <strong>{{ $t("bills.total.current_grand") }}:</strong>
                  </span>
                  <strong>{{
                    account_sales
                      .slice(0, filters.sales_rows)
                      .reduce((sum, item) => sum + item.price, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="alert alert-success d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-cash me-2"></i>
                    <strong>{{ $t("bills.total.current_paid") }}:</strong>
                  </span>
                  <strong>{{
                    account_sales
                      .slice(0, filters.sales_rows)
                      .reduce((sum, item) => sum + item.paid, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="alert alert-danger d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-report-money me-2"></i>
                    <strong>{{ $t("bills.total.current_debt") }}:</strong>
                  </span>
                  <strong>{{
                    account_sales
                      .slice(0, filters.sales_rows)
                      .reduce((sum, item) => sum + item.price, 0) -
                      account_sales
                        .slice(0, filters.sales_rows)
                        .reduce((sum, item) => sum + item.paid, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="card p-4 mb-2">
            <div class="account-bills-total row g-3">
              <div class="col-md-4">
                <div
                  class="alert alert-primary d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-calculator me-2"></i>
                    <strong>{{ $t("bills.total.total_grand") }}:</strong>
                  </span>
                  <strong>{{
                    account.sales.reduce((sum, item) => sum + item.price, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="alert alert-success d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-cash me-2"></i>
                    <strong>{{ $t("bills.total.total_paid") }}:</strong>
                  </span>
                  <strong>{{
                    account.sales.reduce((sum, item) => sum + item.paid, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="alert alert-danger d-flex align-items-center justify-content-between"
                  role="alert"
                >
                  <span>
                    <i class="ti ti-report-money me-2"></i>
                    <strong>{{ $t("bills.total.total_debt") }}:</strong>
                  </span>
                  <strong>{{
                    account.sales.reduce((sum, item) => sum + item.price, 0) -
                      account.sales.reduce((sum, item) => sum + item.paid, 0) +
                      settings.currency
                  }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-show="activeTab === 'tab-alerts'"
          v-if="hasPrivilege('accounts_notifications_accounts')"
          class="tab-content-box"
        >
          <div class="card mb-2">
            <div class="card-datatable">
              <div class="dataTables_wrapper dt-bootstrap5 no-footer">
                <div class="row mx-1" bis_skin_checked="1">
                  <div
                    class="col-12 col-md-9 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dataTables_length"
                      id="DataTables_Table_0_length"
                      bis_skin_checked="1"
                    >
                      <label
                        >{{ $t("control.show") }}
                        <select
                          name="DataTables_Table_0_length"
                          aria-controls="DataTables_Table_0"
                          class="form-select"
                          v-model="filters.notifications_rows"
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </label>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-3 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <div class="btn-group" id="dropdown-icon-demo">
                        <button
                          type="button"
                          class="btn btn-info dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i class="ti ti-upload ti-xs me-2"></i>
                          {{ $t("control.export") }}
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-printer me-2"></i>Print</a
                            >
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-file me-2"></i>Csv</a
                            >
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-file-export me-2"></i>Excel</a
                            >
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item d-flex align-items-center"
                              ><i class="ti ti-file-text me-2"></i>Pdf</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dataTables_scroll" bis_skin_checked="1">
                  <div
                    class="dataTables_scrollBody table-container"
                    bis_skin_checked="1"
                    style="position: relative; overflow: auto; width: 100%; height: 440px;"
                  >
                    <table
                      class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                      id="DataTables_Table_0"
                      aria-describedby="DataTables_Table_0_info"
                    >
                      <thead>
                        <tr class="text-nowrap">
                          <th>
                            <input class="form-check-input" type="checkbox" />
                          </th>
                          <th>{{ $t("notifications.title") }}</th>
                          <th>{{ $t("notifications.notification_text") }}</th>
                          <th>{{ $t("notifications.type.type") }}</th>
                          <th>{{ $t("notifications.sender") }}</th>
                          <th>{{ $t("notifications.status") }}</th>
                          <th>{{ $t("notifications.notified_at") }}</th>
                        </tr>
                      </thead>
                      <tbody class="table-border-bottom-0 ">
                        <tr
                          v-for="notification in account.notifications.slice(
                            0,
                            filters.notifications_rows,
                          )"
                          :key="notification.id"
                        >
                          <td>
                            <input class="form-check-input" type="checkbox" />
                          </td>
                          <td>{{ notification.title }}</td>
                          <td
                            style="white-space:pre-wrap; word-wrap:break-word; direction:rtl"
                          >
                            {{ notification.body }}
                          </td>
                          <td>
                            <span
                              class="badge bg-label-primary me-1"
                              :class="{
                                'bg-label-secondary ':
                                  notification.type == 'account_expired',
                                'bg-label-warning ':
                                  notification.type == 'account_expiring',
                                'bg-label-success ':
                                  notification.type == 'account_renew',
                                ' bg-label-primary ':
                                  notification.type == 'account' ||
                                  notification.type == 'profile' ||
                                  notification.type == 'nas',
                                ' bg-label-info text-indigo-200 ':
                                  notification.type == 'ssr',
                                ' bg-label-dark ':
                                  notification.type == 'global',
                                'bg-label-warning ': notification.type.includes(
                                  'support',
                                ),
                              }"
                              >{{
                                $t(`notifications.type.${notification.type}`)
                              }}</span
                            >
                          </td>
                          <td>{{ notification.sender }}</td>
                          <td>
                            <span
                              class="badge me-1"
                              :class="{
                                'bg-label-success':
                                  notification.status == 'new',
                                'bg-label-secondary':
                                  notification.status == 'archived',
                              }"
                              >{{
                                $t(`notifications.${notification.status}`)
                              }}</span
                            >
                          </td>
                          <td>
                            {{ formatDateHours(notification.created_at) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-1" bis_skin_checked="1">
                  <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_info"
                      id="DataTables_Table_0_info"
                      role="status"
                      aria-live="polite"
                      bis_skin_checked="1"
                    >
                      {{
                        $t("control.pagination", {
                          from: 1,
                          to: filters.notifications_rows,
                          total: account.notifications.length,
                        })
                      }}
                    </div>
                  </div>

                  <!-- <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                      id="DataTables_Table_0_paginate"
                      bis_skin_checked="1"
                    >
                      <ul class="pagination">
                        <li
                          class="paginate_button page-item previous disabled"
                          id="DataTables_Table_0_previous"
                        >
                          <a
                            aria-controls="DataTables_Table_0"
                            aria-disabled="true"
                            role="link"
                            data-dt-idx="previous"
                            tabindex="-1"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-left ti-sm"></i>
                          </a>
                        </li>
                        <li class="paginate_button page-item active">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            aria-current="page"
                            data-dt-idx="0"
                            tabindex="0"
                            class="page-link"
                            >1</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="1"
                            tabindex="0"
                            class="page-link"
                            >2</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="2"
                            tabindex="0"
                            class="page-link"
                            >3</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="3"
                            tabindex="0"
                            class="page-link"
                            >4</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="4"
                            tabindex="0"
                            class="page-link"
                            >5</a
                          >
                        </li>
                        <li
                          class="paginate_button page-item next"
                          id="DataTables_Table_0_next"
                        >
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="next"
                            tabindex="0"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-right ti-sm"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-show="activeTab === 'tab-maintenance'"
          v-if="hasPrivilege('accounts_support_accounts')"
          class="tab-content-box"
        >
          <div class="card mb-2">
            <div class="card-datatable">
              <div class="dataTables_wrapper dt-bootstrap5 no-footer">
                <div class="row mx-1" bis_skin_checked="1">
                  <div
                    class="col-12 col-md-9 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dataTables_length"
                      id="DataTables_Table_0_length"
                      bis_skin_checked="1"
                    >
                      <label
                        >{{ $t("control.show") }}
                        <select
                          name="DataTables_Table_0_length"
                          aria-controls="DataTables_Table_0"
                          class="form-select"
                          v-model="filters.support_tickets_rows"
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </label>
                    </div>
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <div
                        class="dt-buttons btn-group flex-wrap"
                        bis_skin_checked="1"
                      >
                        <div class="btn-group" id="dropdown-icon-demo">
                          <button
                            type="button"
                            class="btn btn-info dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="ti ti-upload ti-xs me-2"></i>
                            {{ $t("control.export") }}
                          </button>
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                href="javascript:void(0);"
                                class="dropdown-item d-flex align-items-center"
                                ><i class="ti ti-printer me-2"></i>Print</a
                              >
                            </li>
                            <li>
                              <a
                                href="javascript:void(0);"
                                class="dropdown-item d-flex align-items-center"
                                ><i class="ti ti-file me-2"></i>Csv</a
                              >
                            </li>
                            <li>
                              <a
                                href="javascript:void(0);"
                                class="dropdown-item d-flex align-items-center"
                                ><i class="ti ti-file-export me-2"></i>Excel</a
                              >
                            </li>
                            <li>
                              <a
                                href="javascript:void(0);"
                                class="dropdown-item d-flex align-items-center"
                                ><i class="ti ti-file-text me-2"></i>Pdf</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-3 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <!-- <button
                        class="btn btn-primary waves-effect waves-light"
                        tabindex="0"
                        aria-controls="DataTables_Table_0"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#add-ticket"
                      >
                        <span>
                          <i class="ti ti-plus ti-xs me-2"></i>
                          <span class=" ">{{
                            $t("support_tickets.add_ticket")
                          }}</span>
                        </span>
                      </button> -->
                    </div>
                  </div>
                </div>
                <div class="dataTables_scroll" bis_skin_checked="1">
                  <div
                    class="dataTables_scrollBody table-container"
                    bis_skin_checked="1"
                    style="position: relative; overflow: auto; width: 100%; height: 440px;"
                  >
                    <table
                      class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                      id="DataTables_Table_0"
                      aria-describedby="DataTables_Table_0_info"
                    >
                      <thead>
                        <tr class="text-nowrap">
                          <th>
                            <input class="form-check-input" type="checkbox" />
                          </th>
                          <th>#</th>
                          <th>{{ $t("support_tickets.issue") }}</th>
                          <th>{{ $t("support_tickets.priority.priority") }}</th>
                          <th>{{ $t("support_tickets.status") }}</th>
                          <th>{{ $t("support_tickets.notes") }}</th>
                          <th>{{ $t("support_tickets.ssr_comment") }}</th>
                          <th>{{ $t("control.created_at") }}</th>
                          <th>{{ $t("control.actions") }}</th>
                        </tr>
                      </thead>
                      <tbody class="table-border-bottom-0 ">
                        <tr
                          v-for="support_ticket in account.support_tickets"
                          :key="support_ticket.id"
                        >
                          <td>
                            <input class="form-check-input" type="checkbox" />
                          </td>
                          <td>{{ support_ticket.id }}</td>
                          <td>{{ support_ticket.issue }}</td>
                          <td>
                            <span
                              class="badge bg-label-secondary me-1"
                              v-if="support_ticket.priority == '0'"
                              >{{ $t("support_tickets.priority.low") }}</span
                            >
                            <span
                              class="badge bg-label-info me-1"
                              v-if="support_ticket.priority == '1'"
                              >{{ $t("support_tickets.priority.normal") }}</span
                            >
                            <span
                              class="badge bg-label-warning me-1"
                              v-if="support_ticket.priority == '2'"
                              >{{ $t("support_tickets.priority.high") }}</span
                            >
                          </td>
                          <td>
                            <span
                              class="badge bg-label-primary me-1"
                              v-if="support_ticket.status == 'new'"
                              >{{ $t("support_tickets.new") }}</span
                            >
                            <span
                              class="badge bg-label-warning me-1"
                              v-if="support_ticket.status == 'in_progress'"
                              >{{ $t("support_tickets.in_progress") }}</span
                            >
                            <span
                              class="badge bg-label-success me-1"
                              v-if="support_ticket.status == 'resolved'"
                              >{{ $t("support_tickets.resolved") }}</span
                            >
                            <span
                              class="badge bg-label-danger me-1"
                              v-if="support_ticket.status == 'failed'"
                              >{{ $t("support_tickets.failed") }}</span
                            >
                          </td>
                          <td>
                            <span class="text-muted">{{
                              support_ticket.notes
                            }}</span>
                          </td>
                          <td>{{ support_ticket.ssr_notes }}</td>
                          <td>{{ formatDate(support_ticket.created_at) }}</td>
                          <td>
                            <a href="#" class="btn btn-icon btn-sm btn-primary">
                              <i class="ti ti-edit"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-1" bis_skin_checked="1">
                  <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_info"
                      id="DataTables_Table_0_info"
                      role="status"
                      aria-live="polite"
                      bis_skin_checked="1"
                    >
                      {{
                        $t("control.pagination", {
                          from: 1,
                          to: filters.support_tickets_rows,
                          total: account.support_tickets.length,
                        })
                      }}
                    </div>
                  </div>

                  <!-- <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                      id="DataTables_Table_0_paginate"
                      bis_skin_checked="1"
                    >
                      <ul class="pagination">
                        <li
                          class="paginate_button page-item previous disabled"
                          id="DataTables_Table_0_previous"
                        >
                          <a
                            aria-controls="DataTables_Table_0"
                            aria-disabled="true"
                            role="link"
                            data-dt-idx="previous"
                            tabindex="-1"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-left ti-sm"></i>
                          </a>
                        </li>
                        <li class="paginate_button page-item active">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            aria-current="page"
                            data-dt-idx="0"
                            tabindex="0"
                            class="page-link"
                            >1</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="1"
                            tabindex="0"
                            class="page-link"
                            >2</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="2"
                            tabindex="0"
                            class="page-link"
                            >3</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="3"
                            tabindex="0"
                            class="page-link"
                            >4</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="4"
                            tabindex="0"
                            class="page-link"
                            >5</a
                          >
                        </li>
                        <li
                          class="paginate_button page-item next"
                          id="DataTables_Table_0_next"
                        >
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="next"
                            tabindex="0"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-right ti-sm"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-show="activeTab === 'tab-sessions'"
          v-if="hasPrivilege('accounts_sessions_accounts')"
          class="tab-content-box"
        >
          <div class="card mb-2">
            <div class="card-datatable">
              <div class="dataTables_wrapper dt-bootstrap5 no-footer">
                <div class="row mx-1" bis_skin_checked="1">
                  <div
                    class="col-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dataTables_length"
                      id="DataTables_Table_0_length"
                      bis_skin_checked="1"
                    >
                      <label
                        >{{ $t("control.show") }}
                        <select
                          name="DataTables_Table_0_length"
                          aria-controls="DataTables_Table_0"
                          class="form-select"
                          v-model="filters.sessions_rows"
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </label>
                    </div>
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                    >
                      <a
                        @click.prevent="
                          $router.push(`/sessions?username=${account.username}`)
                        "
                        :href="`/sessions?username=${account.username}`"
                        type="button"
                        class="btn btn-primary"
                      >
                        <i class="ti ti-eye me-2"></i>
                        {{ $t("control.show_more_details") }}
                      </a>
                    </div>
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <div
                        class="dt-buttons btn-group flex-wrap"
                        bis_skin_checked="1"
                      >
                        <div class="btn-group" id="dropdown-icon-demo">
                          <button
                            type="button"
                            class="btn btn-info dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="ti ti-upload ti-xs me-2"></i>
                            {{ $t("control.export") }}
                          </button>
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                href="javascript:void(0);"
                                class="dropdown-item d-flex align-items-center"
                                ><i class="ti ti-printer me-2"></i>Print</a
                              >
                            </li>
                            <li>
                              <a
                                href="javascript:void(0);"
                                class="dropdown-item d-flex align-items-center"
                                ><i class="ti ti-file me-2"></i>Csv</a
                              >
                            </li>
                            <li>
                              <a
                                href="javascript:void(0);"
                                class="dropdown-item d-flex align-items-center"
                                ><i class="ti ti-file-export me-2"></i>Excel</a
                              >
                            </li>
                            <li>
                              <a
                                href="javascript:void(0);"
                                class="dropdown-item d-flex align-items-center"
                                ><i class="ti ti-file-text me-2"></i>Pdf</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-5 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
                    bis_skin_checked="1"
                  >
                    <div
                      class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                      bis_skin_checked="1"
                    >
                      <button
                        class="btn btn-danger waves-effect waves-light"
                        v-if="hasPrivilege('accounts_clear_sessions')"
                        :class="{
                          disabled_ssr: !this.$store.getters.settings.license
                            .active,
                        }"
                        @click="confirmDeleteAllSessions"
                      >
                        <span>
                          <i class="ti ti-trash ti-xs me-2"></i>
                          <span>{{ $t("accounts.delete_all_sessions") }}</span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="dataTables_scroll" bis_skin_checked="1">
                  <div
                    class="dataTables_scrollBody table-container"
                    bis_skin_checked="1"
                    style="position: relative; overflow: auto; width: 100%; height: 440px;"
                  >
                    <table
                      class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                      id="DataTables_Table_0"
                      aria-describedby="DataTables_Table_0_info"
                    >
                      <thead>
                        <tr class="text-nowrap">
                          <th>
                            <input class="form-check-input" type="checkbox" />
                          </th>
                          <th>#</th>
                          <th>{{ $t("online.mac_address") }}</th>
                          <th>{{ $t("online.ip_address") }}</th>
                          <th>{{ $t("online.network") }}</th>
                          <th>{{ $t("online.interface") }}</th>
                          <th>{{ $t("online.usage") }}</th>
                          <th>{{ $t("online.session_duration") }}</th>
                          <th>{{ $t("online.connect_time") }}</th>
                          <th>{{ $t("online.disconnect_time") }}</th>
                        </tr>
                      </thead>
                      <tbody class="table-border-bottom-0 ">
                        <tr
                          v-for="(session, index) in account.sessions.slice(
                            0,
                            filters.sessions_rows,
                          )"
                          :key="session.radacctid"
                        >
                          <td>
                            <input class="form-check-input" type="checkbox" />
                          </td>

                          <td dir="ltr">{{ session.radacctid }}</td>
                          <td>{{ session.callingstationid }}</td>
                          <td>
                            <a
                              :href="`http://${session.framedipaddress}`"
                              target="_blank"
                              @click.prevent="
                                openTab(`http://${session.framedipaddress}`)
                              "
                              >{{ session.framedipaddress }}</a
                            >
                          </td>
                          <td>{{ session.nasipaddress }}</td>
                          <td>{{ session.nasportid }}</td>
                          <td>
                            <span class="badge bg-label-info mb-2 me-1">{{
                              formatTraffic(session.acctoutputoctets)
                            }}</span>
                            <span class="badge bg-label-danger me-1">{{
                              formatTraffic(session.acctinputoctets)
                            }}</span>
                          </td>
                          <td>
                            <span class="badge bg-warning">{{
                              formatTime(session.acctsessiontime)
                            }}</span>
                          </td>
                          <td>{{ session.acctstarttime }}</td>
                          <td>{{ session.acctstoptime }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-1" bis_skin_checked="1">
                  <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_info"
                      id="DataTables_Table_0_info"
                      role="status"
                      aria-live="polite"
                      bis_skin_checked="1"
                    >
                      {{
                        $t("control.pagination", {
                          from: 1,
                          to: filters.sessions_rows,
                          total: account.sessions.length,
                        })
                      }}
                    </div>
                  </div>

                  <!-- <div class="col-sm-12 col-md-6" bis_skin_checked="1">
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                      id="DataTables_Table_0_paginate"
                      bis_skin_checked="1"
                    >
                      <ul class="pagination">
                        <li
                          class="paginate_button page-item previous disabled"
                          id="DataTables_Table_0_previous"
                        >
                          <a
                            aria-controls="DataTables_Table_0"
                            aria-disabled="true"
                            role="link"
                            data-dt-idx="previous"
                            tabindex="-1"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-left ti-sm"></i>
                          </a>
                        </li>
                        <li class="paginate_button page-item active">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            aria-current="page"
                            data-dt-idx="0"
                            tabindex="0"
                            class="page-link"
                            >1</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="1"
                            tabindex="0"
                            class="page-link"
                            >2</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="2"
                            tabindex="0"
                            class="page-link"
                            >3</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="3"
                            tabindex="0"
                            class="page-link"
                            >4</a
                          >
                        </li>
                        <li class="paginate_button page-item ">
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="4"
                            tabindex="0"
                            class="page-link"
                            >5</a
                          >
                        </li>
                        <li
                          class="paginate_button page-item next"
                          id="DataTables_Table_0_next"
                        >
                          <a
                            href="#"
                            aria-controls="DataTables_Table_0"
                            role="link"
                            data-dt-idx="next"
                            tabindex="0"
                            class="page-link"
                          >
                            <i class="ti ti-chevron-right ti-sm"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-show="activeTab === 'tab-usage'"
          v-if="hasPrivilege('accounts_usage_accounts')"
          class="tab-content-box"
        >
          <div class="card mb-6 h-100">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <div>
                <h4 class="mb-1">{{ $t("accounts.traffic_usage_chart") }}</h4>
              </div>

              <div class="card-action-element ms-auto py-0">
                <div class="dropdown">
                  <button
                    type="button"
                    class="btn dropdown-toggle px-0"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-calendar"></i>
                    <span>{{
                      $t(`accounts.usage_filters.${filters.usage_filter_by}`)
                    }}</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        @click="
                          filters.usage_filter_by = 'today';
                          createUsageChart();
                        "
                        >{{ $t(`accounts.usage_filters.today`) }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        @click="
                          filters.usage_filter_by = 'yesterday';
                          createUsageChart();
                        "
                        >{{ $t(`accounts.usage_filters.yesterday`) }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        @click="
                          filters.usage_filter_by = 'this_week';
                          createUsageChart();
                        "
                        >{{ $t(`accounts.usage_filters.this_week`) }}</a
                      >
                    </li>
                    <li>
                      <hr class="dropdown-divider" />
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        @click="
                          filters.usage_filter_by = 'this_month';
                          createUsageChart();
                        "
                        >{{ $t(`accounts.usage_filters.this_month`) }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        @click="
                          filters.usage_filter_by = 'last_month';
                          createUsageChart();
                        "
                        >{{ $t(`accounts.usage_filters.last_month`) }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        @click="
                          filters.usage_filter_by = 'this_year';
                          createUsageChart();
                        "
                        >{{ $t(`accounts.usage_filters.this_year`) }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div id="internetUsageChart"></div>
            </div>
          </div>
          <div class="card h-100">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h4 class="mb-1">{{ $t("accounts.live_speed_chart") }}</h4>
            </div>
            <div class="card-body" v-if="account">
              <div v-for="(session, index) in account.active_sessions">
                <button
                  v-if="hasPrivilege('accounts_disconnect_accounts')"
                  class="btn btn-danger waves-effect waves-light"
                  @click="confirmDisconnectSession(session)"
                >
                  <span>
                    <i class="ti ti-wifi-off ti-xs me-2"></i>
                    <span>{{ $t("accounts.disconnect") }}</span>
                  </span>
                </button>
                <div class="row text-center mb-0">
                  <div class="col-12">
                    <h5 class="mb-0">{{ session.callingstationid }}</h5>
                  </div>
                  <div class="col-12">
                    <h5 class="mb-0">{{ session.framedipaddress }}</h5>
                  </div>
                </div>
                <div :id="`internetLiveUsageChart${session.radacctid}`"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="bill_print_page"
      v-if="selectedBill"
      class="bill-container noScreen"
    >
      <!-- Print button, hidden during printing -->
      <!-- Main bill content -->
      <div class="bill-content">
        <!-- Header with company info -->
        <div class="bill-header text-center">
          <div v-if="settings.print.network_logo" class="flex justify-center">
            <img
              :src="server_url + settings.network_logo"
              style="height: 4rem; width: 4rem;"
            />
          </div>
          <!-- <div v-if="settings.print.network_name" class="company-name">
            {{ settings.network_name }}
          </div> -->
        </div>

        <!-- Profile and billing period -->
        <div class="bill-summary">
          <div class="summary-item">
            <span>{{ $t("bills.invoice.bill_to") }}</span>
            <span
              >{{ selectedBill.account.first_name }}
              {{ selectedBill.account.last_name }}</span
            >
          </div>
          <div v-if="settings.print.address" class="summary-item">
            <span>{{
              this.$store.getters.settings.center == 1
                ? "رقم البوابة"
                : $t("accounts.address")
            }}</span>
            <span>{{ selectedBill.account.address }}</span>
          </div>
          <div v-if="settings.print.phone" class="summary-item">
            <span>{{ $t("accounts.phone") }}</span>
            <span style="direction: ltr;">{{
              selectedBill.account.phone
            }}</span>
          </div>
          <div v-if="settings.print.phone_line" class="summary-item">
            <span>{{ $t("accounts.phone_line") }}</span>
            <span style="direction: ltr;">{{
              selectedBill.account.phone_line
            }}</span>
          </div>
          <div v-if="settings.print.issued_date" class="summary-item">
            <span>{{ $t("bills.invoice.issued_date") }}</span>
            <span>{{ formatDate(selectedBill.created_at) }}</span>
          </div>
          <div v-if="settings.print.account_id" class="summary-item">
            <span>{{ $t("bills.invoice.account_id") }}</span>
            <span>{{ selectedBill.account.id }}</span>
          </div>
          <div v-if="settings.print.bill_id" class="summary-item">
            <span>{{ $t("bills.invoice.bill_id") }}</span>
            <span>{{ selectedBill.id }}</span>
          </div>
          <div v-if="settings.print.bill_slug" class="summary-item">
            <span>{{ $t("bills.slug") }}</span>
            <span>{{ selectedBill.slug }}</span>
          </div>
          <div v-if="settings.print.profile" class="summary-item">
            <span>{{ $t("bills.invoice.profile") }}:</span>
            <span class="font-bold" dir="ltr">{{
              selectedBill.profile.name
            }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.from") }}:</span>
            <span class="font-bold">{{ formatDate(selectedBill.from) }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.to") }}:</span>
            <span class="font-bold">{{ formatDate(selectedBill.to) }}</span>
          </div>
          <div class="summary-item" v-if="!settings.print.price_table">
            <span>{{ $t("bills.invoice.amount") }}:</span>
            <span class="font-bold"
              >{{ selectedBill.price }}
              <span class="font-bold">{{ settings.currency }}</span></span
            >
          </div>
        </div>

        <!-- Itemized table -->
        <table class="bill-table" v-if="settings.print.price_table">
          <thead>
            <tr>
              <th colspan="2">{{ $t("bills.invoice.description") }}</th>
              <th>{{ $t("bills.invoice.amount") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="2">{{ $t("bills.price") }}</td>
              <td>
                {{ selectedBill.price }}
                <span class="font-bold">{{ settings.currency }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="2">{{ $t("bills.paid") }}</td>
              <td>
                {{ selectedBill.paid }}
                <span class="font-bold">{{ settings.currency }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">{{ $t("bills.invoice.remaining") }}</th>
              <th>
                {{ selectedBill.price - selectedBill.paid }}
                <span class="font-bold">{{ settings.currency }}</span>
              </th>
            </tr>
          </tfoot>
        </table>

        <!-- Issued by and signature -->
        <div class="bill-issuer" v-if="settings.print.signature">
          <div>{{ $t("bills.invoice.issued_by") }}:</div>
          <div>{{ user.first_name }} {{ user.last_name }}</div>
          <div>{{ formatDate(selectedBill.created_at) }}</div>
          <img
            v-if="user.signature"
            :src="server_url + user.signature"
            class="signature"
          />
        </div>

        <!-- Notes -->
        <div v-if="selectedBill.notes" class="bill-notes">
          <div>{{ $t("bills.notes") }}:</div>
          <div>{{ selectedBill.notes }}</div>
        </div>

        <!-- Footer -->
        <div class="bill-footer">
          <div>{{ settings.network_name }}</div>
          <div style="direction: ltr;">{{ settings.phone_number }}</div>
          <div>{{ settings.status_url }}</div>
        </div>
      </div>
    </div>
    <!-- <div v-if="selectedBill" id="bill_print_page">
      <div class="grid grid-cols-8 justify-center w-full p-6 text-black">
        <div class="col-span-2 flex flex-col justify-center items-center">
          <img :src="server_url + settings.network_logo" class="h-32" />
          <div class="text-2xl">{{ settings.network_name }}</div>
        </div>
        <div class="col-span-8 h-12"></div>
        <div class="col-span-2 flex flex-col items-start justify-start">
          <div class="font-bold">{{ $t("bills.invoice.bill_to") }}:</div>
          <div>
            {{
              selectedBill.account.first_name +
                " " +
                selectedBill.account.last_name
            }}
          </div>
          <div>
            {{ selectedBill.account.address }}
          </div>
          <div style="direction: ltr;">
            {{ selectedBill.account.phone }}
          </div>
          <div>
            {{ selectedBill.account.phone_line }}
          </div>
        </div>
        <div
          class="col-span-3 col-start-6 flex flex-col items-start justify-start"
        >
          <div class="w-full flex justify-between">
            <div>{{ $t("bills.invoice.issued_date") }}:</div>
            <div>{{ formatDate(selectedBill.created_at) }}</div>
          </div>
          <div class="w-full flex justify-between">
            <div>{{ $t("bills.invoice.account_id") }}:</div>
            <div>{{ selectedBill.account.id }}</div>
          </div>
          <div class="w-full flex justify-between">
            <div>{{ $t("bills.invoice.bill_id") }}:</div>
            <div>{{ selectedBill.id }}</div>
          </div>
          <div class="w-full flex justify-between">
            <div>{{ selectedBill.slug }}</div>
          </div>
        </div>
        <div class="col-span-8 h-6"></div>
        <div
          class="flex flex-col col-span-2 bg-yellow-300 text-black justify-center text-xl border-gray-100 border p-4"
        >
          <div>{{ $t("bills.invoice.profile") }}:</div>
          <div class="font-bold">{{ selectedBill.profile.name }}</div>
        </div>
        <div
          class="flex flex-col col-span-2 bg-yellow-300 text-black justify-center text-xl border-gray-100 border p-4"
        >
          <div>{{ $t("bills.from") }}:</div>
          <div class="font-bold">{{ formatDate(selectedBill.from) }}</div>
        </div>
        <div
          class="flex flex-col col-span-2 bg-yellow-300 text-black justify-center text-xl border-gray-100 border p-4"
        >
          <div>{{ $t("bills.to") }}:</div>
          <div class="font-bold">{{ formatDate(selectedBill.to) }}</div>
        </div>
        <div
          class="flex flex-col col-span-2 bg-gray-800 text-white justify-center text-xl border-gray-100 border p-4"
        >
          <div>{{ $t("bills.price") }}:</div>
          <div class="font-bold font-sans">
            {{ selectedBill.price + settings.currency }}
          </div>
        </div>
        <div class="col-span-8 h-6"></div>

        <div class="col-span-8" style="text-align: end;">
          <table class="w-full">
            <thead class="font-bold border-b-2 border-black">
              <tr>
                <th colspan="2" class="px-2">
                  {{ $t("bills.invoice.description") }}
                </th>
                <th>{{ $t("bills.invoice.amount") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-black border-t border-b">
                <td colspan="2" class="px-2">
                  {{ $t("bills.price") }}
                </td>
                <td>
                  {{ selectedBill.price }}
                  <span class="font-sans font-bold">{{
                    settings.currency
                  }}</span>
                </td>
              </tr>
              <tr class="border-black border-t border-b">
                <td colspan="2" class="px-2">
                  {{ $t("bills.paid") }}
                </td>
                <td>
                  {{ selectedBill.paid }}
                  <span class="font-sans font-bold">{{
                    settings.currency
                  }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot class=" border-t-2 border-black">
              <tr>
                <th colspan="2" class="px-2">
                  {{ $t("bills.invoice.remaining") }}
                </th>
                <th>
                  {{ selectedBill.price - selectedBill.paid }}
                  <span class="font-sans font-bold">{{
                    settings.currency
                  }}</span>
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="col-span-2 col-start-6 mt-12">
          <div>{{ $t("bills.invoice.issued_by") }}:</div>
          <div>{{ user.first_name + " " + user.last_name }}</div>
          <div>
            {{ formatDate(selectedBill.created_at) }}
          </div>
          <img
            v-if="user.signature"
            :src="server_url + user.signature"
            class="h-16 mt-1"
          />
        </div>
        <div
          v-if="selectedBill.notes"
          class="col-span-8 flex items-start flex-col"
        >
          <div>{{ $t("bills.notes") }}:</div>
          <div>{{ selectedBill.notes }}</div>
        </div>
        <div class="col-span-8 w-full border-b border-black mt-12"></div>
        <div style="direction: ltr;" class="col-span-3 flex justify-start">
          {{ settings.phone_number }}
        </div>
        <div class="col-span-2 text-center">{{ settings.network_name }}</div>
        <div class="col-span-3 flex justify-end">
          {{ settings.status_url }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import ticketAdd from "../components/modals/ticket-add.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import RenewAccountProfile from "../components/modals/renew-account-profile.vue";
import SalesPay from "../components/modals/sales-pay.vue";
import { hasPrivilege, print_element } from "../global_constants";
import BillsPay from "../components/modals/bills-pay.vue";
import BillsNotify from "../components/modals/bills-notify.vue";
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LIcon } from "@vue-leaflet/vue-leaflet";

export default {
  components: {
    ticketAdd,
    RenewAccountProfile,
    SalesPay,
    BillsPay,
    BillsNotify,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      zoom: 14,
      activeTab: "tab-subscription",
      tabs: [
        {
          id: "tab-subscription",
          label: this.$t("accounts.subscription"),
          icon: "ti ti-wifi",
          privilege: true,
        },
        {
          id: "tab-bills",
          label: this.$t("accounts.bills"),
          icon: "ti ti-receipt",
          privilege: this.hasPrivilege("accounts_bills_accounts"),
        },
        {
          id: "tab-purchases",
          label: this.$t("sales.purchases"),
          icon: "ti ti-shopping-cart",
          privilege: this.hasPrivilege("accounts_sales_accounts"),
        },
        {
          id: "tab-alerts",
          label: this.$t("accounts.alerts"),
          icon: "ti ti-bell",
          privilege: this.hasPrivilege("accounts_notifications_accounts"),
        },
        {
          id: "tab-maintenance",
          label: this.$t("accounts.support_tickets"),
          icon: "ti ti-tools",
          privilege: this.hasPrivilege("accounts_support_accounts"),
        },
        {
          id: "tab-sessions",
          label: this.$t("accounts.sessions"),
          icon: "ti ti-device-desktop",
          privilege: this.hasPrivilege("accounts_sessions_accounts"),
        },
        {
          id: "tab-usage",
          label: this.$t("accounts.usage"),
          icon: "ti ti-chart-bar",
          privilege: this.hasPrivilege("accounts_usage_accounts"),
        },
      ],
      lat: 36.203225,
      lng: 36.167066,
      account: {
        id: null,
        name: "",
        email: "",
        phone: "",
        address: "",
        status: "",
        created_at: "",
        updated_at: "",
        profile_id: null,
        next_profile_id: null,
        profile: {
          name: "",
        },
        sessions: [],
        bills: [],
        notifications: [],
        support_tickets: [],
        sales: [],
        gps_coordinates: "",
        active_sessions: [],
        has_static_ip: false,
        is_mac: false,
        nid_image_back_url: null,
        nid_image_front_url: null,
        nid_image_front: null,
        nid_image_back: null,
      },
      showRenew: false,
      withdrawDialogVisible: false,
      depositDialogVisible: false,
      profiles: [],
      resellers: [],
      filters: {
        sessions_rows: 10,
        bills_rows: 10,
        sales_rows: 10,
        support_tickets_rows: 10,
        notifications_rows: 10,
        usage_filter_by: "today",
      },
      account_bills: [],
      account_sales: [],
      temp_speed: {
        upload_rate_kb: 1,
        download_rate_kb: 1,
        session_seconds: 1,
        factor: 3600,
      },
      deposit: {
        amount: 0,
        date: new Date(),
      },
      withdraw: {
        amount: 0,
        date: new Date(),
      },
      usage_chart: null,
      live_charts: [],
      live_traffic_timer: null,
      edit_location: false,
      sale: {
        id: null,
        name: "",
        description: "",
        notes: "",
        price: 0,
        paid: 0,
      },
      errors: {
        username: null,
        password: null,
        ip_address: null,
        public_ip_port: null,
        mac_address: null,
      },
      validated: true,
      ip_pools: [],
      private_ips: [],
      public_ips: [],
      selectedSale: null,
      selectedBill: null,
      server_url: localStorage.getItem("server"),
      account_icon_url: require("@/assets/img/map/1.svg"),
    };
  },
  async created() {
    const savedTab = localStorage.getItem("activeTabId");
    if (savedTab) {
      this.activeTab = savedTab;
    }
    await this.fetchAccount();
    this.fetchProfiles();
    this.fetchResellers();
    this.fetchIpPools();
    this.fetchPublicIpPorts();
    if (savedTab == "tab-usage") {
      this.createCharts();
      this.live_traffic_timer = setInterval(() => {
        this.fetchLiveTrafficData();
      }, 5000);
    }
    if (this.$store.getters.settings.type == "local") {
      this.initUploaders();
    }
  },
  unmounted() {
    if (this.live_traffic_timer != null) {
      clearInterval(this.live_traffic_timer);
      this.live_traffic_timer = null;
    }
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    print_element(id) {
      print_element(id);
    },
    async printBill(bill) {
      this.selectedBill = bill;
      await this.$nextTick();
      await this.print_element("bill_print_page");
    },
    async fetchAccount() {
      const response = await axios.get(`/accounts/${this.$route.params.id}`);
      if (response.status == 200) {
        this.account = response.data.data;
        this.account.fixed_expiration = moment(this.account.expires_at).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        this.account_bills = this.account.bills;
        this.account_sales = this.account.sales;
        if (this.account.ip_address != null) {
          this.account.has_static_ip = true;
        }
        if (this.account.mac_address != null) {
          this.account.is_mac = true;
        }
        if (this.account.nid_image_front) {
          const response = await axios.get(
            `/accounts/${this.account.nid_image_front.id}/image`,
            {
              responseType: "blob",
            },
          );
          if (response.status == 200) {
            this.account.nid_image_front_url = URL.createObjectURL(
              response.data,
            );
          }
        }
        if (this.account.nid_image_back) {
          const response = await axios.get(
            `/accounts/${this.account.nid_image_back.id}/image`,
            {
              responseType: "blob",
            },
          );
          if (response.status == 200) {
            this.account.nid_image_back_url = URL.createObjectURL(
              response.data,
            );
          }
        }
      }
    },
    initUploaders() {
      const previewTemplate = `<div class="dz-preview dz-file-preview">
<div class="dz-details">
  <div class="dz-thumbnail">
    <img data-dz-thumbnail>
    <span class="dz-nopreview">No preview</span>
    <div class="dz-success-mark"></div>
    <div class="dz-error-mark"></div>
    <div class="dz-error-message"><span data-dz-errormessage></span></div>
    <div class="progress">
      <div class="progress-bar progress-bar-primary" role="progressbar" aria-valuemin="0" aria-valuemax="100" data-dz-uploadprogress></div>
    </div>
  </div>
  <div class="dz-filename" data-dz-name></div>
  <div class="dz-size" data-dz-size></div>
</div>
</div>`;

      const dropzoneConfigs = [
        { selector: ".dropzone-basic", options: { maxFiles: 1 } },
        { selector: ".dropzone-multi", options: {} },
      ];

      let resumable_nas = this.resumable_nas;
      let _this = this;
      Dropzone.autoDiscover = false;
      dropzoneConfigs.forEach(({ selector, options }) => {
        document.querySelectorAll(selector).forEach((el) => {
          if (!el.classList.contains("dz-clickable")) {
            new Dropzone(el, {
              url: el.getAttribute("action") || "/upload",
              previewTemplate,
              parallelUploads: 1,
              maxFilesize: 5,
              addRemoveLinks: true,
              acceptedFiles: el.getAttribute("accept") || null,
              init: function() {
                const dz = this;
                this.on("addedfile", function(file) {
                  if (el.getAttribute("face") == "front") {
                    _this.account.nid_image_front = file;
                  } else if (el.getAttribute("face") == "back") {
                    _this.account.nid_image_back = file;
                  }
                });
                this.on("removedfile", function(file) {
                  if (el.getAttribute("face") == "front") {
                    _this.account.nid_image_front = null;
                  } else if (el.getAttribute("face") == "back") {
                    _this.account.nid_image_back = null;
                  }
                });
              },
              // ...options,
            });
          }
        });
      });
    },
    async fetchProfiles() {
      const response = await axios.get(`/profiles?itr=true&rows=1000`);
      if (response.status == 200) {
        this.profiles = response.data.data;
      }
    },
    async fetchIpPools() {
      const response = await axios.get("/ip/pool?itr=1&rows=1000000");
      if (response.status == 200) this.ip_pools = response.data.data;
      if (this.account.ip_pool_id != null) await this.fetchPoolIps(true);
    },
    async fetchPoolIps(one_time = false) {
      if (one_time) this.loading = true;
      const response = await axios.get(
        `/ip/private?itr=1&state=unused&ip_pool=${this.account.ip_pool_id}&rows=1000000&account_id=${this.account.id}`,
      );
      if (response.status == 200) this.private_ips = response.data.data;
      if (one_time) this.loading = false;
    },
    async fetchPublicIpPorts() {
      const response = await axios.get(
        `/ip/port?itr=1&state=unused&rows=1000000&account_id=${this.account.id}`,
      );
      if (response.status == 200) this.public_ips = response.data.data;
    },
    async fetchResellers() {
      const response = await axios.get(
        "admins?filter=1&type=resellers&rows=10000&itr=true",
      );
      if (response.status == 200) this.resellers = response.data.data;
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    formatDateHours(date) {
      //todo fix UTC BUG
      if (date == "never" || date == "" || date == null) return "N/A";
      return moment(date).format("DD-MM-YYYY hh:mm");
    },
    formatSpeed(speed) {
      if (speed < 0 || speed == null) return "∞";
      if (speed > 1023) return speed / 1024 + " Mb/s";
      else return speed + " Kb/s";
    },
    formatTraffic(octets) {
      const bytes = octets ?? 0; // 1 octet = 1 byte
      const units = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      let value = bytes;

      while (value >= 1024 && i < units.length - 1) {
        value /= 1024;
        i++;
      }

      return `${value.toFixed(1)} ${units[i]}`;
    },
    formatTrafficMB(_mb) {
      const mb = _mb; // 1 octet = 1 byte
      const units = ["MB", "GB", "TB"];
      let i = 0;
      let value = mb;

      while (value >= 1024 && i < units.length - 1) {
        value /= 1024;
        i++;
      }

      return `${value.toFixed(1)} ${units[i]}`;
    },
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);

      const parts = [];
      if (hours > 0) parts.push(`${hours} h`);
      if (minutes > 0 || hours === 0) parts.push(`${minutes} m`);

      return parts.join(" ");
    },
    setActiveTab(tabId) {
      this.activeTab = tabId;
      localStorage.setItem("activeTabId", tabId);
      if (tabId == "tab-usage") {
        this.createCharts();
        this.live_traffic_timer = setInterval(() => {
          this.fetchLiveTrafficData();
        }, 5000);
      } else {
        if (this.live_traffic_timer != null) {
          clearInterval(this.live_traffic_timer);
          this.live_traffic_timer = null;
          this.live_charts.forEach((chart) => {
            chart.destroy();
          });
          this.usage_chart.destroy();
        }
      }
    },
    selectedItemsCount(items) {
      return items.filter((item) => item.selected).length;
    },
    toggleAllSelected(items) {
      const newState = !items.allSelected;
      items.forEach((item) => {
        item.selected = newState;
      });
      items.allSelected = newState;
    },
    async showRenewDialog() {
      this.showRenew = true;
      await this.$nextTick();
      var modalElement = document.getElementById("renew-account-profile");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    },
    confirmRenew(bill) {
      this.showRenew = false;
      this.selectedBill = bill;
      this.fetchAccount();
      this.$swal({
        title: this.$t("accounts.renew"),
        text: this.$t("accounts.account_has_been_renewed_successfully"),
        icon: "success",
        confirmButtonText: this.$t("accounts.print_bill"),
        cancelButtonText: this.$t("accounts.close"),
        buttonsStyling: false,
        showCancelButton: true,
        backdrop: true,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-label-success",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.printBill(bill);
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    deactivateAccount() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("accounts.this_will_deactivate_account_temporarily"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_deactivate"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(
              `accounts/${this.account.id}/disable`,
            );
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("accounts.deactivated"),
              text: this.$t("accounts.the_account_has_been_deactivated"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "info",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    activateAccount() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("accounts.this_will_reactivate_account"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_activate"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(
              `accounts/${this.account.id}/disable`,
            );
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("accounts.activated"),
              text: this.$t("accounts.account_has_been_reactivated"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "info",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },

    confirmDeleteAccount() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("accounts.this_will_delete_account_permanently"),
        icon: "error",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`accounts/${this.account.id}`);
            if (response.status == 200) {
              this.$router.push("/accounts");
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t(
                "accounts.the_account_has_been_permanently_deleted",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "info",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmDeleteAllBills() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("accounts.this_will_delete_all_bills_permanently"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("accounts.all_bills_have_been_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmDeleteAllSessions() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("accounts.this_will_delete_all_sessions_permanently"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(
              `sessions/truncate/account/${this.account.id}`,
            );
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("accounts.all_sessions_have_been_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmDisconnect() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "accounts.this_will_disconnect_the_user_from_the_internet",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_disconnect"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(
              `accounts/${this.account.id}/disconnect`,
            );
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("control.disconnect"),
              text: this.$t(
                "accounts.the_user_has_been_disconnected_from_the_internet",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmDisconnectSession(session) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text:
          this.$t("accounts.this_will_disconnect_the_user_from_the_internet") +
          " " +
          session.framedipaddress,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_disconnect"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(
              `online/disconnect/${session.radacctid}`,
            );
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("control.disconnect"),
              text: this.$t(
                "accounts.the_user_has_been_disconnected_from_the_internet",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmRenewManual() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "accounts.this_will_set_the_subscription_to_manual_renewal",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_set_manual"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`/accounts/${this.account.id}`, {
              auto_renew: 0,
            });
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("control.update"),
              text: this.$t(
                "accounts.suscription_is_now_set_to_manual_renewal",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmRenewAuto() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "accounts.this_will_set_the_subscription_to_auto_renewal",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_set_auto"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`/accounts/${this.account.id}`, {
              auto_renew: 1,
            });
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("control.update"),
              text: this.$t("accounts.susbcription_is_now_set_to_auto_renewal"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmAdd2FreeDays() {
      this.$swal({
        title: this.$t("accounts.add_2_free_days"),
        text: this.$t("accounts.this_will_add_2_free_days_to_the_subscription"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_add_2_days"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-primary",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(
              `accounts/${this.account.id}/renew/temp/free`,
            );
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("accounts.two_free_days_added_to_the_subscription"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmAdd3TempDays() {
      this.$swal({
        title: this.$t("accounts.add_3_temp_days"),
        text: this.$t("accounts.this_will_add_3_temp_days_to_the_subscription"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_add_3_days"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-primary",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(
              `accounts/${this.account.id}/renew/72`,
            );
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t(
                "accounts.three_temp_days_added_to_the_subscription",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmAdd2TempDays() {
      this.$swal({
        title: this.$t("accounts.add_2_temp_days"),
        text: this.$t("accounts.this_will_add_2_temp_days_to_the_subscription"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_add_2_days"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-primary",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(
              `accounts/${this.account.id}/renew/temp`,
            );
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("accounts.two_temp_days_added_to_the_subscription"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: this.$t("control.cancel"),
            text: this.$t("control.the_operation_was_cancelled"),
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },

    async submitAccountChanges() {
      try {
        const modalElement = document.getElementById("editUser");
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
        const fileds = [
          "first_name",
          "last_name",
          "father_name",
          "mother_name",
          "national_id",
          "phone",
          "phone_line",
          "email",
          "country",
          "state",
          "city",
          "neighborhood",
          "street",
          "address",
          "gps_coordinates",
          "notes",
          "nid_image_back",
          "nid_image_front",
        ];
        var formData = new FormData();
        fileds.forEach((key) => {
          if (
            this.account[key] != null &&
            this.account[key] != undefined &&
            this.account[key] != ""
          )
            formData.append(key, this.account[key]);
        });

        const response = await axios.post(
          `/accounts/${this.account.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response.status == 200) {
          this.fetchAccount();
          this.$swal({
            icon: "success",
            title: this.$t("control.changes_saved_successfully"),
            showConfirmButton: false,
            timer: 1500,
          });
        } else if (response.status == 210) {
          let errr = "";
          if (response.data.error == "invalid_nid_image_front") {
            errr = "INVALID FRONT IMAGE";
          }
          if (response.data.error == "invalid_nid_back_front") {
            errr = "INVALID BACK IMAGE";
          }
          this.$swal({
            icon: "error",
            title: errr,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error while saving changes",
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          confirmButtonText: this.$t("control.ok"),
        });
      }
    },
    async submitAccountDetailsChanges() {
      try {
        const modalElement = document.getElementById("editAccountD");
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
        const response = await axios.put(`/accounts/${this.account.id}`, {
          username: this.account.username,
          password: this.account.password,
          fixed_expiration: moment(this.account.fixed_expiration).format(
            "yyyy-MM-DD HH:mm",
          ),
          profile_id: this.account.profile_id,
          reseller_id: this.account.reseller_id,
          allowed_sessions: this.account.allowed_sessions,
          ip_address: this.account.has_static_ip
            ? this.account.ip_address
            : null,
          mac_address: this.account.has_static_ip
            ? this.account.mac_address
            : null,
          next_profile_id: this.account.next_profile_id,
          public_ip_port_id: this.account.public_ip_port_id,
          private_ip_id: this.account.private_ip_id,
        });
        if (response.status == 200) {
          this.fetchAccount();
        }
        this.$swal({
          icon: "success",
          title: this.$t("control.changes_saved_successfully"),
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: this.$t("control.error_while_saving_changes"),
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          confirmButtonText: this.$t("control.ok"),
        });
      }
    },
    submitchangeSubscription() {
      try {
        const modalElement = document.getElementById("changeSubscriptionModal");
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
        //   const response = await axios.post(
        //   `/accounts/${this.selectedAccount.id}/renew`,
        //   {
        //     profile_id: this.selectedAccount.profile.id,
        //     expires_at: moment(this.date).format("yyyy-MM-DD HH:mm"),
        //     profile_price: this.profile_price,
        //     renew_amount: this.renew_amount,
        //     in_debt: !this.in_debt,
        //     paid_amount: this.paid,
        //     discount: this.discount,
        //     previous_quota: this.previous_quota,
        //     next_profile_id: this.selectedAccount.next_profile_id,
        //   }
        // );
        this.$swal({
          icon: "success",
          title: this.$t("control.changes_saved_successfully"),
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: this.$t("control.error_while_saving_changes"),
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          confirmButtonText: this.$t("control.ok"),
        });
      }
    },
    async submitTemporarySpeedChange() {
      try {
        const modalElement = document.getElementById("tempSpeedModal");
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
        this.temp_speed.download_rate_kb =
          this.temp_speed.download_rate_kb * 1024;
        this.temp_speed.upload_rate_kb = this.temp_speed.upload_rate_kb * 1024;
        this.temp_speed.session_seconds =
          this.temp_speed.session_seconds * this.temp_speed.factor;
        const response = await axios.post(
          `accounts/${this.account.id}/speed/temp`,
          this.temp_speed,
        );
        if (response.status == 200) {
          this.temp_speed = {
            download_rate_kb: 1,
            upload_rate_kb: 1,
            session_seconds: 1,
            factor: 3600,
          };
        }
        this.$swal({
          icon: "success",
          title: this.$t("accounts.speed_updated_temporarily"),
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: this.$t("accounts.error_while_changing_speed"),
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          confirmButtonText: this.$t("control.ok"),
        });
      }
    },
    async showWithdrawDialog() {
      this.withdrawDialogVisible = true;
      await this.$nextTick();
      const modalElement = document.getElementById("WithdrawModal");
      if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
      }
    },
    async showDepositDialog() {
      this.depositDialogVisible = true;
      await this.$nextTick();
      const modalElement = document.getElementById("DepositModal");
      if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
      }
    },
    async WithdrawAlert() {
      try {
        const modalElement = document.getElementById("WithdrawModal");
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
        const response = await axios.post(
          `accounts/${this.account.id}/money/withdraw`,
          this.withdraw,
        );
        if (response.status == 200) {
          this.fetchAccount();
        }
        this.$swal({
          icon: "success",
          title: this.$t("control.changes_saved_successfully"),
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: this.$t("control.error"),
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          confirmButtonText: this.$t("control.ok"),
        });
      }
      this.withdrawDialogVisible = false;
    },
    async DepositAlert() {
      try {
        const modalElement = document.getElementById("DepositModal");
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
        const response = await axios.post(
          `accounts/${this.account.id}/money/deposit`,
          this.deposit,
        );
        if (response.status == 200) {
          this.fetchAccount();
        }
        this.$swal({
          icon: "success",
          title: this.$t("control.changes_saved_successfully"),
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: this.$t("control.error"),
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          confirmButtonText: this.$t("control.ok"),
        });
      }
      this.depositDialogVisible = false;
    },
    async storeSale() {
      this.loading = true;
      this.sale.account_id = this.account.id;
      const response = await axios.post("sales", this.sale);
      if (response.status == 200) {
        document.getElementById("add-sale-close").click();
        this.$notify({
          text: this.$t("sales.new_sale_added"),
          type: "success",
        });
        this.fetchAccount();
        this.sale = {
          id: null,
          name: "",
          description: "",
          notes: "",
          price: 0,
          paid: 0,
        };
        this.loading = false;
      }
    },
    async deleteSale(sale) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("sales.this_will_delete_sale_record"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("sales.yes_delete"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`sales/${sale.id}`);
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("sales.deleteted"),
              text: this.$t("sales.sale_has_been_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async deleteBill(bill) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "bills.this_will_delete_bill_and_return_expiration_to_previous_value",
        ),
        icon: "danger",
        showCancelButton: true,
        confirmButtonText: this.$t("bills.yes_delete"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`bills/${bill.id}`);
            if (response.status == 200) {
              this.fetchAccount();
            }
            this.$swal({
              title: this.$t("actions.delete"),
              text: this.$t("bills.bill_has_been_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async showPaySaleDialog(sale) {
      this.selectedSale = sale;
      await this.$nextTick();
      var modalElement = document.getElementById("paySalesModal");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.selectedSale = null;
      });
      modalInstance.show();
    },
    async showPayBillDialog(bill) {
      this.selectedBill = bill;
      await this.$nextTick();
      var modalElement = document.getElementById("payBillsModal");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.selectedBill = null;
      });
      modalInstance.show();
    },
    async showNotifyBillDialog(bill) {
      this.selectedBill = bill;
      await this.$nextTick();
      var modalElement = document.getElementById("notifyBillsModal");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.selectedBill = null;
      });
      modalInstance.show();
    },
    async onMapClick(event) {
      if (!this.edit_location) return;
      const latLng = event.latlng;
      this.account.latitude = latLng.lat;
      this.account.longitude = latLng.lng;
      try {
        const response = await axios.put(`accounts/${this.account.id}`, {
          latitude: this.account.latitude,
          longitude: this.account.longitude,
        });
        if (response.status == 200) {
          console.log("success");
        }
        this.$notify({
          title: this.$t("control.success"),
          text: this.$t("maps.location_updated_successfully"),
          type: "success",
          duration: 2000,
        });
      } catch (error) {
        this.$notify({
          title: this.$t("control.error"),
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          type: "error",
          duration: 2000,
        });
      }
      this.edit_location = false;
    },
    async createCharts() {
      this.createUsageChart();
      this.createLiveCharts();
    },
    async createUsageChart() {
      if (this.usage_chart) {
        this.usage_chart.destroy();
      }
      const chartEl = document.querySelector("#internetUsageChart");
      const response = await axios.get(
        `sessions/usage?username=${this.account.username}&filter_by=${this.filters.usage_filter_by}`,
      );
      let categories = [
        "10:00",
        "10:05",
        "10:10",
        "10:15",
        "10:20",
        "10:25",
        "10:30",
        "10:35",
        "10:40",
        "10:45",
      ];
      let downloadData = [4.2, 5.1, 3.8, 6.3, 8.4, 7.2, 5.5, 6.7, 4.9, 6.1];
      let uploadData = [1.8, 2.1, 1.5, 2.4, 3.2, 2.8, 2.2, 2.6, 1.9, 2.5];
      if (response.status == 200) {
        let groupedData = response.data.data;
        categories = groupedData.map((item) => item.time_interval);
        downloadData = groupedData.map((item) => item.total_download_bytes);
        uploadData = groupedData.map((item) => item.total_upload_bytes);
      }
      const options = {
        series: [
          {
            name: "Download",
            data: downloadData,
          },
          {
            name: "Upload",
            data: uploadData,
          },
        ],
        chart: {
          type: "bar",
          height: 320,
          toolbar: { show: false },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 9,
            columnWidth: "80%",
          },
        },
        colors: ["#7367F0", "#28C76F"],
        xaxis: {
          categories: categories,
          labels: {
            style: {
              fontSize: "12px",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => `${val} Bytes`,
            style: {
              fontSize: "12px",
            },
            show: false,
          },
        },
        grid: {
          strokeDashArray: 5,
        },
        tooltip: {
          y: {
            formatter: (val) => this.formatTraffic(val),
          },
        },
        dataLabels: {
          enabled: false,
          formatter: (val) => this.formatTraffic(val),
        },
        legend: {
          show: false,
          position: "bottom",
          fontSize: "14px",
        },
      };

      if (chartEl) {
        this.usage_chart = new ApexCharts(chartEl, options);
        this.usage_chart.render();
      }
    },
    async createLiveCharts() {
      this.account.active_sessions.forEach((session) => {
        const chartEl = document.querySelector(
          `#internetLiveUsageChart${session.radacctid}`,
        );
        let categories = [];
        let downloadData = [];
        let uploadData = [];
        const options = {
          series: [
            {
              name: "Download",
              data: downloadData,
            },
            {
              name: "Upload",
              data: uploadData,
            },
          ],
          chart: {
            height: 320,
            type: "area",
            toolbar: { show: false },
            zoom: { enabled: false },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          colors: ["#7367F0", "#28C76F"],
          xaxis: {
            categories: categories,
            tooltip: {
              enabled: false,
            },
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            min: 0,
            tickAmount: 4,
            labels: {
              formatter: (val) => `${Number(val / 1000).toFixed(1)} Mbps`,
              style: {
                fontSize: "13px",
              },
            },
          },
          legend: {
            show: true,
            position: "bottom",
            fontSize: "14px",
            fontWeight: 500,
            markers: {
              width: 10,
              height: 10,
              radius: 12,
            },
            itemMargin: {
              horizontal: 10,
              vertical: 4,
            },
            labels: {
              colors: "#5d596c",
              useSeriesColors: false,
            },
            formatter: function(seriesName, opts) {
              return [
                seriesName,
                " - ",
                `${Number(
                  opts.w.globals.series[opts.seriesIndex][
                    opts.w.globals.series[opts.seriesIndex].length - 1
                  ] / 1000,
                ).toFixed(1)} Mbps`,
              ];
            },
          },
          tooltip: {
            shared: true,
            x: {
              show: true,
            },
            y: {
              formatter: (val) => `${Number(val / 1000).toFixed(1)} Mbps`,
            },
          },
          grid: {
            strokeDashArray: 5,
          },
        };

        if (chartEl) {
          let chart = new ApexCharts(chartEl, options);
          chart.render();
          chart.uploadData = uploadData;
          chart.downloadData = downloadData;
          chart.categories = categories;
          this.live_charts.push(chart);
          // setTimeout(() => {
          //   chart.updateOptions({
          //     xaxis: {
          //       categories: moment().format("YYYY-MM-DD hh:mm:ss"),
          //     },
          //   });
          //   chart.updateSeries([
          //     {
          //       name: "Download",
          //       data: [2],
          //     },
          //     {
          //       name: "Upload",
          //       data: [1],
          //     },
          //   ]);
          // });
        }
      });
    },
    openTab(url) {
      window.open(url, "_blank");
    },
    async copyToClip(mytext) {
      await navigator.clipboard.writeText(mytext);
      this.$notify({
        text: this.$t("control.copied_to_clipboard"),
        type: "info",
      });
    },
    fetchLiveTrafficData() {
      this.account.active_sessions.forEach(async (session, index) => {
        var id = this.account.active_sessions[index].radacctid;
        const response = await axios.get(
          `sessions/traffic/${id}?index=${index}`,
        );
        if (response.status == 200) {
          const result = response.data.data;
          this.live_charts[index].categories = [
            ...this.live_charts[index].categories,
            moment().format("YYYY-MM-DD hh:mm:ss"),
          ];
          this.live_charts[index].downloadData = [
            ...this.live_charts[index].downloadData,
            result.tx,
          ];
          this.live_charts[index].uploadData = [
            ...this.live_charts[index].uploadData,
            result.rx,
          ];
          this.live_charts[index].updateOptions({
            xaxis: {
              categories: this.live_charts[index].categories,
            },
          });
          this.live_charts[index].updateSeries([
            {
              name: "Download",
              data: this.live_charts[index].downloadData,
            },
            {
              name: "Upload",
              data: this.live_charts[index].uploadData,
            },
          ]);
        }
      });
    },
    validate() {
      this.validated = true;
      this.errors.username = null;
      this.errors.mac_address = null;
      this.errors.public_ip_port = null;
      if (!this.account.username) {
        this.errors.username = this.$t("errors.accounts.username_empty");
        this.validated = false;
      }
      if (this.account.username.length < 2) {
        this.validated = false;
        this.errors.username = this.$t("errors.accounts.username_2");
      }
      if (this.account.username.includes("*")) {
        this.validated = false;
        this.errors.username = this.$t("errors.accounts.username_symbol");
      }
      if (
        this.account.username.indexOf("@") !=
        this.account.username.lastIndexOf("@")
      ) {
        this.validated = false;
        this.errors.username = "cannot contain more than @ symbol";
      }
      this.errors.password = null;
      if (!this.account.password) {
        this.validated = false;
        this.errors.password = this.$t("errors.accounts.password_empty");
      }
      if (this.account.password.length < 2) {
        this.validated = false;
        this.errors.password = this.$t("errors.accounts.password_2");
      }
      this.errors.ip_address = null;
      if (
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          this.account.ip_address,
        ) == false &&
        this.has_static_ip
      ) {
        this.validated = false;
        this.errors.ip_address = this.$t("errors.accounts.invalid_ip");
      }
      if (
        /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})|([0-9a-fA-F]{4}\\.[0-9a-fA-F]{4}\\.[0-9a-fA-F]{4})$/.test(
          this.account.mac_address,
        ) == false &&
        this.account.is_mac == 1 &&
        this.account.mac_address != ""
      ) {
        this.errors.mac_address = this.$t(
          "errors.accounts.invalid_mac_address",
        );
        this.validated = false;
      }
      if (this.account.is_mac) {
        this.account.allowed_sessions = 1;
      }
      if (
        this.account.private_ip_id &&
        this.account.ip_pool_id &&
        !this.account.public_ip_port_id
      ) {
        this.errors.public_ip_port = this.$t("errors.ips.ip_required");
        this.validated = false;
      }
    },
  },
};
</script>
